<template>
  <div>
    <b-row>
      <b-col xl="6" lg="12">
        <b-card no-body v-if="mostrarSemAct">
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="1" lg="1" md="1" class="mb-1" align="center">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="mostrarSemAct = false"
                      id="btn_back"
                      v-b-tooltip.hover="'Regresar'"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrow-left-long"/>
                  </b-button>
                </b-button-group>
              </b-col>
              <b-col xl="11" lg="11" md="1" class="mb-1" align="center">
                <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Detalle de registro - Total: ${this.items_sem_act.length}` }}</span>
              </b-col>
            </b-row>
          </b-card-body>

          <b-table
              v-if="$can('read', 'Pr Rieg Programacion')"
              ref="tableDetalleSemanaActual"
              responsive
              hover
              outlined
              small
              sticky-header="58vh"
              class="position-relative tablaferti"
              :items="items_sem_act"
              :fields="fields_detalle_SemAct"
              :busy="loading"
              show-empty
              empty-text="No se encontraron datos en esta tabla."
          >
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(acciones)="data" v-if="this.responsable[0].rol === 'ADMINISTRADOR' || this.responsable[0].rol === 'USUARIO'">
              <div class="text-nowrap">
                <feather-icon
                    v-if="$can('update', 'Pr Rieg Programacion')"
                    :id="`btn_${data.item.id}_editar`"
                    icon="EditIcon"
                    size="16"
                    @click="validarEditar(data.item, true)"
                    v-b-tooltip.hover="'Editar registro'"
                />
              </div>
            </template>

            <template #cell(estado)="data">
              <b-badge :variant="status[1][parseInt(data.value)]">
                {{ status[0][parseInt(data.value)] }}
              </b-badge>
            </template>

            <template #cell(created)="data">
          <span>
            {{
              new Date(data.value).toLocaleString('pe-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                localeMatcher: 'best fit',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: 'America/Lima'
              })
            }}
          </span>
            </template>
          </b-table>
        </b-card>

        <b-card no-body v-else>
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="3" lg="3" md="3" class="mb-1 align-self-center">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="traerRiegos"
                      id="act_semAct"
                      :disabled="loading"
                      v-b-tooltip.hover="'Actualizar Tabla'"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
                  </b-button>
                  <b-button
                      v-if="$can('create', 'Pr Rieg Programacion') && ( this.responsable[0].rol === 'ADMINISTRADOR' || this.responsable[0].rol ==='USUARIO' )"
                      variant="gradient-primary"
                      size="sm"
                      @click="modal_registro(true)"
                      id="cre_semAct"
                      :disabled="loadingSAC"
                      v-b-tooltip.hover="'Crear Registro'"
                  >
                    <font-awesome-icon v-if="loadingSAC" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-plus"/>
                  </b-button>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      v-if="$can('create', 'Pr Rieg Programacion') && ( this.responsable[0].rol === 'ADMINISTRADOR' || this.responsable[0].rol ==='USUARIO' )"
                      @click="mostrarModalImportar(true)"
                      id="imp_semAct"
                      :disabled="loadingSAM"
                      v-b-tooltip.hover="'Importar Registros'"
                  >
                    <font-awesome-icon v-if="loadingSAM" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-file-excel"/>
                  </b-button>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      v-if="$can('authorize', 'Pr Rieg Programacion')"
                      @click="descargarRegistros(true)"
                      id="imp_semAct"
                      :disabled="loadingSAD"
                      v-b-tooltip.hover="'Descargar Registros'"
                  >
                    <font-awesome-icon v-if="loadingSAM" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-download"/>
                  </b-button>
                </b-button-group>
              </b-col>
              <b-col xl="9" lg="9" md="9" class="mb-1" align="center">
                <span class="font-weight-bolder font-medium-3" style="vertical-align: -webkit-baseline-middle!important;">{{`Semana actual N° ${this.semana}`}}</span><br>
                <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Del ${this.inicioSemana} al ${this.finSemana}` }}</span>
              </b-col>
            </b-row>
          </b-card-body>

          <b-table
              v-if="$can('read', 'Pr Rieg Programacion')"
              ref="tableSemanaActual"
              responsive
              hover
              outlined
              small
              sticky-header="58vh"
              class="position-relative tablaferti"
              :items="items"
              :fields="fields"
              :filter="filter"
              :filter-included-fields="filterOn"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @filtered="cPaginacion"
              :busy="loading"
              show-empty
              empty-text="No se encontraron datos en esta tabla."
              emptyFilteredText="No se encontraron datos con los parámetros ingresados."
          >
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(acciones)="data">
              <div class="text-nowrap">

                <feather-icon
                    v-if="$can('read', 'Pr Rieg Programacion')"
                    :id="`btn_${data.item.id}_detalle`"
                    icon="EyeIcon"
                    size="16"
                    class="mr-1 text-primary"
                    @click="verDetalle(data.item)"
                    v-b-tooltip.hover="'Ver detalle'"
                />
                <feather-icon
                    v-if="$can('authorize', 'Pr Rieg Programacion')"
                    :id="`btn_${data.item.id}_autorizar`"
                    icon="UserCheckIcon"
                    size="16"
                    @click="autorizar(data.item)"
                    v-b-tooltip.hover="'Cambiar Estado'"
                />

              </div>
            </template>

            <template #cell(estado)="data">
              <b-badge :variant="status[1][parseInt(data.value)]">
                {{ status[0][parseInt(data.value)] }}
              </b-badge>
            </template>

            <template #cell(created)="data">
              <span>
                {{
                  new Date(data.value).toLocaleString('pe-PE', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    localeMatcher: 'best fit',
                    hour: '2-digit',
                    minute: '2-digit',
                    timeZone: 'America/Lima'
                  })
                }}
              </span>
            </template>
          </b-table>
        </b-card>
      </b-col>
      <b-col xl="6" lg="12">
        <b-card no-body v-if="mostrarSemSgte">
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="1" lg="1" md="1" class="mb-1" align="center">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="mostrarSemSgte = false"
                      id="btn_backSgte"
                      v-b-tooltip.hover="'Regresar'"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrow-left-long"/>
                  </b-button>
                </b-button-group>
              </b-col>
              <b-col xl="11" lg="11" md="1" class="mb-1" align="center">
                <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Detalle de registro - Total: ${this.items_sem_sgte.length}` }}</span>
              </b-col>

            </b-row>
          </b-card-body>

          <b-table
              v-if="$can('read', 'Pr Rieg Programacion')"
              ref="tableDetalleSemanaSgte"
              responsive
              hover
              outlined
              small
              sticky-header="58vh"
              class="position-relative tablaferti"
              :items="items_sem_sgte"
              :fields="fields_detalle_SemAct"
              :busy="loading"
              show-empty
              empty-text="No se encontraron datos en esta tabla."
          >
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(acciones)="data">
              <div class="text-nowrap">
                <feather-icon
                    v-if="$can('update', 'Pr Rieg Programacion')"
                    :id="`btn_${data.item.id}_editar`"
                    icon="EditIcon"
                    size="16"
                    @click="validarEditar(data.item, false)"
                    v-b-tooltip.hover="'Editar registro'"
                />
              </div>
            </template>

            <template #cell(estado)="data">
              <b-badge :variant="status[1][parseInt(data.value)]">
                {{ status[0][parseInt(data.value)] }}
              </b-badge>
            </template>

            <template #cell(created)="data">
          <span>
            {{
              new Date(data.value).toLocaleString('pe-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                localeMatcher: 'best fit',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: 'America/Lima'
              })
            }}
          </span>
            </template>
          </b-table>
        </b-card>

        <b-card no-body v-else>
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="3" lg="3" md="3" class="mb-1 align-self-center">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="traerRiegos"
                      id="act_semSgte"
                      :disabled="loading"
                      v-b-tooltip.hover="'Actualizar Tabla'"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
                  </b-button>
                  <b-button
                  v-if="$can('create', 'Pr Rieg Programacion') && ( this.responsable[0].rol=== 'ADMINISTRADOR' || this.responsable[0].rol ==='USUARIO' )"
                      variant="gradient-primary"
                      size="sm"
                      @click="modal_registro(false)"
                      id="cre_semSgte"
                      :disabled="loadingSSC"
                      v-b-tooltip.hover="'Crear Registro'"
                  >
                    <font-awesome-icon v-if="loadingSSC" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-plus"/>
                  </b-button>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      v-if="$can('create', 'Pr Rieg Programacion') && ( this.responsable[0].rol=== 'ADMINISTRADOR' || this.responsable[0].rol ==='USUARIO' )"
                      @click="mostrarModalImportar(false)"
                      id="imp_semSgte"
                      :disabled="loadingSSM"
                      v-b-tooltip.hover="'Importar Registros'"
                  >
                    <font-awesome-icon v-if="loadingSSM" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-file-excel"/>
                  </b-button>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      v-if="$can('authorize', 'Pr Rieg Programacion')"
                      @click="descargarRegistros(false)"
                      id="imp_semAct"
                      :disabled="loadingSSD"
                      v-b-tooltip.hover="'Descargar Registros'"
                  >
                    <font-awesome-icon v-if="loadingSAM" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-download"/>
                  </b-button>
                </b-button-group>
              </b-col>
              <b-col xl="9" lg="9" md="9" class="mb-1" align="center">
                <span class="font-weight-bolder font-medium-3" style="vertical-align: -webkit-baseline-middle!important;">{{`Semana siguiente N° ${this.semana_sig}`}}</span><br>
                <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Del ${this.inicioSemana_sig} al ${this.finSemana_sig}` }}</span>
              </b-col>
            </b-row>
          </b-card-body>

          <b-table
              v-if="$can('read', 'Pr Rieg Programacion')"
              ref="tableSemanaSgte"
              responsive
              hover
              outlined
              small
              sticky-header="58vh"
              class="position-relative tablaferti"
              :items="items"
              :fields="fields"
              :filter="filter_sig"
              :filter-included-fields="filterOn"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :busy="loading"
              show-empty
              empty-text="No se encontraron datos en esta tabla."
              emptyFilteredText="No se encontraron datos con los parámetros ingresados."
          >
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(acciones)="data">
              <div class="text-nowrap">
                <feather-icon
                    v-if="$can('read', 'Pr Rieg Programacion')"
                    :id="`btn_${data.item.id}_detalle`"
                    icon="EyeIcon"
                    size="16"
                    class="mr-1 text-primary"
                    @click="verDetalleSemSgte(data.item)"
                    v-b-tooltip.hover="'Ver detalle'"
                />

                <feather-icon
                    v-if="$can('authorize', 'Pr Rieg Programacion')"
                    :id="`btn_${data.item.id}_autorizar`"
                    icon="UserCheckIcon"
                    size="16"
                    @click="autorizar(data.item)"
                    v-b-tooltip.hover="'Cambiar Estado'"
                />

              </div>
            </template>

            <template #cell(estado)="data">
              <b-badge :variant="status[1][parseInt(data.value)]">
                {{ status[0][parseInt(data.value)] }}
              </b-badge>
            </template>

            <template #cell(created)="data">
              <span>
                {{
                  new Date(data.value).toLocaleString('pe-PE', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    localeMatcher: 'best fit',
                    hour: '2-digit',
                    minute: '2-digit',
                    timeZone: 'America/Lima'
                  })
                }}
              </span>
            </template>
          </b-table>
        </b-card>
      </b-col>

    </b-row>

    <!-----------------------MODAL NUEVO REGISTRO----------------------->
    <b-modal
        id="modal-prevent-closing"
        v-model="modal_registro_o"
        ref="my-modal"
        :title="title_sem"
        ok-title="Registrar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        :size="loading2 ? 'md':'xl'"
        :cancel-disabled="loading2"
        :ok-disabled="loading2"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
    >
      <div v-if="loading2"  align="center">
        <p>Registrando ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioRiego" #default="{invalid}">
        <b-form autocomplete="off" @submit.prevent="handleSubmit">
          <!---------------1era fila-----------i-->
          <b-row>
            <b-col lg="2">
              <b-form-group
                  label="Semana"
                  label-for="semana"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Semana"
                    vid="semana"
                    rules="required|integer|between:1,52"
                >
                  <b-form-input
                      id="semana"
                      v-model="semana"
                      :state="errors.length > 0 ? false:null"
                      name="semana"
                      @input="asignarInicioFinSemana"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <div>
                <label for="example-datepicker">Fecha</label>
                <b-form-datepicker
                  id="fecha"
                  v-model="fecha"
                  class="mb-1"
                  :min="fechaInicioSemana"
                  :max="fechaFinSemana"
                  placeholder="Selecionar fecha"
                />
                <!-- <p>Value: '{{ value }}'</p> -->
              </div>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Empresa"
                  label-for="empresa"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Empresa"
                    vid="empresa"
                    rules="required"
                >
                  <v-select
                      id="empresa"
                      v-model="empresa"
                      :options="empresas"
                      placeholder="Seleccionar empresa..."
                      @input="asignarCultivos"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Cultivo"
                  label-for="cultivo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Cultivo"
                    vid="cultivo"
                    rules="required"
                >
                  <v-select
                      id="cultivo"
                      v-model="cultivo"
                      :options="cultivos"
                      placeholder="Seleccionar cultivo..."
                      @input="asignarFundos"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Fundo"
                  label-for="fundo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Fundo"
                    vid="fundo"
                    rules="required"
                >
                  <v-select
                      id="fundo"
                      v-model="fundo"
                      :options="fundos"
                      placeholder="Seleccionar fundo..."
                      @input="asignarEtapas"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!---------------1ra fila------------f-->

          <!---------------2da fila------------i-->
          <b-row>
            <b-col lg="2">
              <b-form-group
                  label="Etapa"
                  label-for="etapa"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Etapa"
                    vid="etapa"
                    rules="required"
                >
                  <v-select
                      id="etapa"
                      v-model="etapa"
                      :options="etapas"
                      placeholder="Seleccionar etapa..."
                      @input="asignarCampos"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Campo"
                  label-for="campo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Campo"
                    vid="campo"
                    rules="required"
                >
                  <v-select
                      id="campo"
                      v-model="campo"
                      :options="campos"
                      placeholder="Seleccionar campo..."
                      @input="asignarTurnos"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Turno"
                  label-for="turno"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Turno"
                    vid="turno"
                    rules="required"
                >
                  <v-select
                      id="turno"
                      v-model="turno"
                      :options="turnos"
                      placeholder="Seleccionar turno..."
                      @input="asignarCodigos"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group label="Estado" label-for="estado_lote">
                <validation-provider #default="{ errors }" name="Estado" vid="estado_lote" rules="required">
                  <v-select
                    id="estado_lote"
                    v-model="estado_lote"
                    :options="estados_lotes"
                    :reduce="estados => estados.value"
                    label="text"
                    key="value"
                    placeholder="Seleccionar estado..."
                    @input="filtrarPorEstadoUno"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                  label="Codigo Homologado"
                  label-for="codigo_h"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Codigo Homologado"
                    vid="codigo_h"
                    rules="required"
                >
                  <v-select
                      id="codigo_h"
                      v-model="codigo_h"
                      :options="codigos_h"
                      :reduce="codigos_h => codigos_h.data"
                      label="codigo_h"
                      key="data"
                      placeholder="Seleccionar codigo..."
                      @input="seleccionarCodigoN"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!---------------2da fila------------f-->

          <!---------------3ra fila------------i-->
          <b-row>
            <b-col lg="3">
              <b-form-group
                  label="Variedad"
                  label-for="variedad"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Variedad"
                    vid="variedad"
                    rules="required"
                >
                  <b-form-input
                      id="variedad"
                      v-model="variedad"
                      :state="errors.length > 0 ? false:null"
                      name="variedad"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Lote"
                  label-for="lote"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Lote"
                    vid="lote"
                    rules="required"
                >
                  <b-form-input
                      id="lote"
                      v-model="lote"
                      :state="errors.length > 0 ? false:null"
                      name="lote"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Valvula"
                  label-for="valvula"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Valvula"
                    vid="valvula"
                    rules="required"
                >
                  <b-form-input
                      id="valvula"
                      v-model="valvula"
                      :state="errors.length > 0 ? false:null"
                      name="valvula"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Área"
                  label-for="area"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Área"
                    vid="area"
                    rules="required"
                >
                  <b-form-input
                      id="area"
                      v-model="area"
                      :state="errors.length > 0 ? false:null"
                      name="area"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!---------------3ra fila------------f-->

          <!---------------4ta fila------------i-->
          <b-row>
            <b-col lg="3">
              <b-form-group
                  label="ETO"
                  label-for="eto"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Eto"
                    vid="eto"
                    rules="required"
                >
                  <b-form-input
                      id="eto"
                      v-model="eto"
                      :state="errors.length > 0 ? false:null"
                      name="eto"
                      @input="calcularLrDia"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                  label="KC"
                  label-for="kc"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Kc"
                    vid="kc"
                    rules="required"
                >
                  <b-form-input
                      id="kc"
                      v-model="kc"
                      :state="errors.length > 0 ? false:null"
                      name="kc"
                      @input="calcularLrDia"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                  label="LR/Día"
                  label-for="lr_dia"
              >
                <validation-provider
                    #default="{ errors }"
                    name="lr_dia"
                    vid="lr_dia"
                    rules="required"
                >
                  <b-form-input
                      id="lr_dia"
                      v-model="lr_dia"
                      :state="errors.length > 0 ? false:null"
                      name="lr_dia"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                  label="Descarga Caudal/Hora (m3/Ha)"
                  label-for="descarga_caudal_hora"
              >
                <validation-provider
                    #default="{ errors }"
                    name="descarga_caudal_hora"
                    vid="descarga_caudal_hora"
                    rules="required"
                >
                  <b-form-input
                      id="descarga_caudal_hora"
                      v-model="descarga_caudal_hora"
                      :state="errors.length > 0 ? false:null"
                      name="descarga_caudal_hora"
                      @input="calcularLrDia"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!---------------4ta fila------------f-->

          <!---------------5ta fila------------i-->
          <b-row>
            <b-col lg="2">
              <b-form-group
                  label="Volumen Total/Dia/Turno"
                  label-for="volumen"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Volumen"
                    vid="volumen"
                    rules="required"

                >
                  <b-form-input
                      id="volumen"
                      v-model="volumen"
                      :state="errors.length > 0 ? false:null"
                      name="volumen"
                      @input="calcularLrDia"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Ciclos de Riego"
                  label-for="ciclo_riego"
              >
                <validation-provider
                    #default="{ errors }"
                    name="ciclos_riego"
                    vid="ciclos_riego"
                    rules="required|between:1,7"
                >
                  <b-form-input
                      id="ciclos_riego"
                      v-model="ciclos_riego"
                      :state="errors.length > 0 ? false:null"
                      name="ciclos_riego"
                      @input="calcularLrDia"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Riego Total (m3/Ha)"
                  label-for="riego_total"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Riego_total"
                    vid="riego_total"
                    rules="required"
                >
                  <b-form-input
                      id="riego_total"
                      v-model="riego_total"
                      :state="errors.length > 0 ? false:null"
                      name="riego_total"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Horas"
                  label-for="horas"
              >
                <validation-provider
                    #default="{ errors }"
                    name="horas"
                    vid="horas"
                    rules="required"
                >
                  <b-form-input
                      id="horas"
                      v-model="horas"
                      :state="errors.length > 0 ? false:null"
                      name="horas"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Riego Cortina"
                  label-for="riego_cortina"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Riego_cortina"
                    vid="riego_cortina"
                    rules="required"
                >
                  <b-form-input
                      id="riego_cortina"
                      v-model="riego_cortina"
                      :state="errors.length > 0 ? false:null"
                      name="riego_cortina"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Con/Sin Fertilizante"
                  label-for="con_sin_fertilizante"
              >
                <validation-provider
                    #default="{ errors }"
                    name="con_sin_fertilizante"
                    vid="con_sin_fertilizante"
                    rules="required"
                >
                  <v-select
                      id="con_sin_fertilizante"
                      v-model="con_sin_fertilizante"
                      :options="con_sin_fertilizantes"
                      :reduce="con_sin_fertilizantes => con_sin_fertilizantes.value"
                      label="text"
                      key="value"
                      placeholder="Seleccionar..."
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!--------------5ta fila-------------f-->

          <!--------------6ta fila-------------i-->
          <b-row>
            <b-col lg="2">
              <b-form-group
                  label="Ciclo I (m3)"
                  label-for="ciclo_1"
              >
                <validation-provider
                    #default="{ errors }"
                    name="ciclo_1"
                    vid="ciclo_1"
                    rules="required"
                >
                  <b-form-input
                      id="ciclo_1"
                      v-model="ciclo_1"
                      :state="errors.length > 0 ? false:null"
                      name="ciclo_1"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="I-Estanque 1"
                  label-for="estanque_uno_1"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_uno_1"
                    vid="estanque_uno_1"
                    rules="required"
                >
                  <b-form-input
                      id="estanque_uno_1"
                      v-model="estanque_uno_1"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_uno_1"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="I-Estanque 2"
                  label-for="estanque_dos_1"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_dos_1"
                    vid="estanque_dos_1"
                    rules="required"
                >
                  <b-form-input
                      id="estanque_dos_1"
                      v-model="estanque_dos_1"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_dos_1"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="I-Estanque 3"
                  label-for="estanque_tres_1"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_tres_1"
                    vid="estanque_tres_1"
                    rules="required"
                >
                  <b-form-input
                      id="estanque_tres_1"
                      v-model="estanque_tres_1"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_tres_1"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="I-Hora de Inicio"
                  label-for="hora_inicio_1"
              >
                <validation-provider
                    #default="{ errors }"
                    name="hora_inicio_1"
                    vid="hora_inicio_1"
                    rules="required"
                >
                  <b-form-timepicker
                      id="hora_inicio_1"
                      v-model="hora_inicio_1"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="ciclos_riego>=2">
              <b-form-group
                  label="Horas para inicio Segundo Ciclo"
                  label-for="horas_inicio_seg_ciclo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="horas_inicio_seg_ciclo"
                    vid="horas_inicio_seg_ciclo"

                >
                  <b-form-input
                      id="horas_inicio_seg_ciclo"
                      v-model="horas_inicio_seg_ciclo"
                      :state="errors.length > 0 ? false:null"
                      name="horas_inicio_seg_ciclo"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!--------------6ta fila-------------f-->


          <!--------------7ma fila------------i--->
          <b-row>
            <b-col lg="2" v-if="(ciclos_riego>=2 && ciclos_riego<8)">
              <b-form-group
                  label="Ciclo II (m3)"
                  label-for="ciclo_2"
              >
                <validation-provider
                    #default="{ errors }"
                    name="ciclo_2"
                    vid="ciclo_2"
                    rules="required"
                >
                  <b-form-input
                      id="ciclo_2"
                      v-model="ciclo_2"
                      :state="errors.length > 0 ? false:null"
                      name="ciclo_2"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=2 && ciclos_riego<8)">
              <b-form-group
                  label="II-Estanque 1"
                  label-for="estanque_uno_2"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_uno_2"
                    vid="estanque_uno_2"

                >
                  <b-form-input
                      id="estanque_uno_2"
                      v-model="estanque_uno_2"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_uno_2"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=2 && ciclos_riego<8)">
              <b-form-group
                  label="II-Estanque 2"
                  label-for="estanque_dos_2"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_dos_2"
                    vid="estanque_dos_2"

                >
                  <b-form-input
                      id="estanque_dos_2"
                      v-model="estanque_dos_2"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_dos_2"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=2 && ciclos_riego<8)">
              <b-form-group
                  label="II-Estanque 3"
                  label-for="estanque_tres_2"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_tres_2"
                    vid="estanque_tres_2"

                >
                  <b-form-input
                      id="estanque_tres_2"
                      v-model="estanque_tres_2"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_tres_2"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=2 && ciclos_riego<8)">
              <b-form-group
                  label="II-Hora de Inicio"
                  label-for="hora_inicio_2"
              >
                <validation-provider
                    #default="{ errors }"
                    name="hora_inicio_2"
                    vid="hora_inicio_2"

                >
                  <b-form-timepicker
                      id="hora_inicio_2"
                      v-model="hora_inicio_2"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=3 && ciclos_riego<8)">
              <b-form-group
                  label="Horas para inicio Tercer Ciclo"
                  label-for="horas_inicio_ter_ciclo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="horas_inicio_ter_ciclo"
                    vid="horas_inicio_ter_ciclo"

                >
                  <b-form-input
                      id="horas_inicio_ter_ciclo"
                      v-model="horas_inicio_ter_ciclo"
                      :state="errors.length > 0 ? false:null"
                      name="horas_inicio_ter_ciclo"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!--------------7ma fila-------------f-->


          <!--------------8va fila-------------i-->
          <b-row>
            <b-col lg="2" v-if="(ciclos_riego>=3 && ciclos_riego<8)">
              <b-form-group
                  label="Ciclo III (m3)"
                  label-for="ciclo_3"
              >
                <validation-provider
                    #default="{ errors }"
                    name="ciclo_3"
                    vid="ciclo_3"

                >
                  <b-form-input
                      id="ciclo_3"
                      v-model="ciclo_3"
                      :state="errors.length > 0 ? false:null"
                      name="ciclo_3"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=3 && ciclos_riego<8)">
              <b-form-group
                  label="III-Estanque 1"
                  label-for="estanque_uno_3"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_uno_3"
                    vid="estanque_uno_3"

                >
                  <b-form-input
                      id="estanque_uno_3"
                      v-model="estanque_uno_3"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_uno_3"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=3 && ciclos_riego<8)">
              <b-form-group
                  label="III-Estanque 2"
                  label-for="estanque_dos_3"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_dos_3"
                    vid="estanque_dos_3"

                >
                  <b-form-input
                      id="estanque_dos_3"
                      v-model="estanque_dos_3"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_dos_3"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=3 && ciclos_riego<8)">
              <b-form-group
                  label="III-Estanque 3"
                  label-for="estanque_tres_3"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_tres_3"
                    vid="estanque_tres_3"

                >
                  <b-form-input
                      id="estanque_tres_3"
                      v-model="estanque_tres_3"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_tres_3"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=3 && ciclos_riego<8)">
              <b-form-group
                  label="III-Hora de Inicio"
                  label-for="hora_inicio_3"
              >
                <validation-provider
                    #default="{ errors }"
                    name="hora_inicio_3"
                    vid="hora_inicio_3"

                >
                  <b-form-timepicker
                      id="hora_inicio_3"
                      v-model="hora_inicio_3"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=4 && ciclos_riego<8)">
              <b-form-group
                  label="Horas para inicio Cuarto Ciclo"
                  label-for="horas_inicio_cuarto_ciclo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="horas_inicio_cuarto_ciclo"
                    vid="horas_inicio_cuarto_ciclo"

                >
                  <b-form-input
                      id="horas_inicio_cuarto_ciclo"
                      v-model="horas_inicio_cuarto_ciclo"
                      :state="errors.length > 0 ? false:null"
                      name="horas_inicio_cuarto_ciclo"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!-------------8va fila--------------f-->

          <!--------------9na fila-------------i-->
          <b-row>
            <b-col lg="2" v-if="(ciclos_riego>=4 && ciclos_riego<8)">
              <b-form-group
                  label="Ciclo IV (m3)"
                  label-for="ciclo_4"
              >
                <validation-provider
                    #default="{ errors }"
                    name="ciclo_4"
                    vid="ciclo_4"
                    rules="required"
                >
                  <b-form-input
                      id="ciclo_4"
                      v-model="ciclo_4"
                      :state="errors.length > 0 ? false:null"
                      name="ciclo_4"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=4 && ciclos_riego<8)">
              <b-form-group
                  label="IV-Estanque 1"
                  label-for="estanque_uno_4"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_uno_4"
                    vid="estanque_uno_4"

                >
                  <b-form-input
                      id="estanque_uno_4"
                      v-model="estanque_uno_4"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_uno_4"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="ciclos_riego>=4">
              <b-form-group
                  label="IV-Estanque 2"
                  label-for="estanque_dos_4"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_dos_4"
                    vid="estanque_dos_4"

                >
                  <b-form-input
                      id="estanque_dos_4"
                      v-model="estanque_dos_4"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_dos_4"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=4 && ciclos_riego<8)">
              <b-form-group
                  label="IV-Estanque 3"
                  label-for="estanque_tres_4"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_tres_4"
                    vid="estanque_tres_4"

                >
                  <b-form-input
                      id="estanque_tres_4"
                      v-model="estanque_tres_4"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_tres_4"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=4 && ciclos_riego<8)">
              <b-form-group
                  label="IV-Hora de Inicio"
                  label-for="hora_inicio_4"
              >
                <validation-provider
                    #default="{ errors }"
                    name="hora_inicio_4"
                    vid="hora_inicio_4"

                >
                  <b-form-timepicker
                      id="hora_inicio_4"
                      v-model="hora_inicio_4"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=5 && ciclos_riego<8)">
              <b-form-group
                  label="Horas para inicio Quinto Ciclo"
                  label-for="horas_inicio_quinto_ciclo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="horas_inicio_quinto_ciclo"
                    vid="horas_inicio_quinto_ciclo"

                >
                  <b-form-input
                      id="horas_inicio_quinto_ciclo"
                      v-model="horas_inicio_quinto_ciclo"
                      :state="errors.length > 0 ? false:null"
                      name="horas_inicio_quinto_ciclo"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!--------------9na fila-------------f-->

          <!--------------10ma fila------------i-->
          <b-row>
            <b-col lg="2" v-if="(ciclos_riego>=5 && ciclos_riego<8)">
              <b-form-group
                  label="Ciclo V (m3)"
                  label-for="ciclo_5"
              >
                <validation-provider
                    #default="{ errors }"
                    name="ciclo_5"
                    vid="ciclo_5"
                    rules="required"
                >
                  <b-form-input
                      id="ciclo_5"
                      v-model="ciclo_5"
                      :state="errors.length > 0 ? false:null"
                      name="ciclo_5"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=5 && ciclos_riego<8)">
              <b-form-group
                  label="V-Estanque 1"
                  label-for="estanque_uno_5"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_uno_5"
                    vid="estanque_uno_5"

                >
                  <b-form-input
                      id="estanque_uno_5"
                      v-model="estanque_uno_5"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_uno_5"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=5 && ciclos_riego<8)">
              <b-form-group
                  label="V-Estanque 2"
                  label-for="estanque_dos_5"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_dos_5"
                    vid="estanque_dos_5"

                >
                  <b-form-input
                      id="estanque_dos_5"
                      v-model="estanque_dos_5"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_dos_5"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=5 && ciclos_riego<8)">
              <b-form-group
                  label="V-Estanque 3"
                  label-for="estanque_tres_5"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_tres_5"
                    vid="estanque_tres_5"

                >
                  <b-form-input
                      id="estanque_tres_5"
                      v-model="estanque_tres_5"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_tres_5"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=5 && ciclos_riego<8)">
              <b-form-group
                  label="V-Hora de Inicio"
                  label-for="hora_inicio_5"
              >
                <validation-provider
                    #default="{ errors }"
                    name="hora_inicio_5"
                    vid="hora_inicio_5"

                >
                  <b-form-timepicker
                      id="hora_inicio_5"
                      v-model="hora_inicio_5"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=6 && ciclos_riego<8)">
              <b-form-group
                  label="Horas para inicio Sexto Ciclo"
                  label-for="horas_inicio_sexto_ciclo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="horas_inicio_sexto_ciclo"
                    vid="horas_inicio_sexto_ciclo"

                >
                  <b-form-input
                      id="horas_inicio_sexto_ciclo"
                      v-model="horas_inicio_sexto_ciclo"
                      :state="errors.length > 0 ? false:null"
                      name="horas_inicio_sexto_ciclo"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!--------------10ma fila------------f-->

          <!---------------11va fila-----------i-->
          <b-row>
            <b-col lg="2" v-if="(ciclos_riego>=6 && ciclos_riego<8)">
              <b-form-group
                  label="Ciclo VI (m3)"
                  label-for="ciclo_6"
              >
                <validation-provider
                    #default="{ errors }"
                    name="ciclo_6"
                    vid="ciclo_6"
                    rules="required"
                >
                  <b-form-input
                      id="ciclo_6"
                      v-model="ciclo_6"
                      :state="errors.length > 0 ? false:null"
                      name="ciclo_6"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=6 && ciclos_riego<8)">
              <b-form-group
                  label="VI-Estanque 1"
                  label-for="estanque_uno_6"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_uno_6"
                    vid="estanque_uno_6"

                >
                  <b-form-input
                      id="estanque_uno_6"
                      v-model="estanque_uno_6"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_uno_6"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=6 && ciclos_riego<8)">
              <b-form-group
                  label="VI-Estanque 2"
                  label-for="estanque_dos_6"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_dos_6"
                    vid="estanque_dos_6"

                >
                  <b-form-input
                      id="estanque_dos_6"
                      v-model="estanque_dos_6"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_dos_6"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=6 && ciclos_riego<8)">
              <b-form-group
                  label="VI-Estanque 3"
                  label-for="estanque_tres_6"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_tres_6"
                    vid="estanque_tres_6"

                >
                  <b-form-input
                      id="estanque_tres_6"
                      v-model="estanque_tres_6"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_tres_6"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=6 && ciclos_riego<8)">
              <b-form-group
                  label="VI-Hora de Inicio"
                  label-for="hora_inicio_6"
              >
                <validation-provider
                    #default="{ errors }"
                    name="hora_inicio_6"
                    vid="hora_inicio_6"

                >
                  <b-form-timepicker
                      id="hora_inicio_6"
                      v-model="hora_inicio_6"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=7 && ciclos_riego<8)">
              <b-form-group
                  label="Horas para inicio Septimo Ciclo"
                  label-for="horas_inicio_septimo_ciclo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="horas_inicio_septimo_ciclo"
                    vid="horas_inicio_septimo_ciclo"

                >
                  <b-form-input
                      id="horas_inicio_septimo_ciclo"
                      v-model="horas_inicio_septimo_ciclo"
                      :state="errors.length > 0 ? false:null"
                      name="horas_inicio_septimo_ciclo"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!---------------11va fila-----------f-->

          <!---------------12va fila-----------i-->
          <b-row>
            <b-col lg="2" v-if="(ciclos_riego>=7 && ciclos_riego<8)">
              <b-form-group
                  label="Ciclo VII (m3)"
                  label-for="ciclo_7"
              >
                <validation-provider
                    #default="{ errors }"
                    name="ciclo_7"
                    vid="ciclo_7"

                >
                  <b-form-input
                      id="ciclo_7"
                      v-model="ciclo_7"
                      :state="errors.length > 0 ? false:null"
                      name="ciclo_7"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=7 && ciclos_riego<8)">
              <b-form-group
                  label="VII-Estanque 1"
                  label-for="estanque_uno_7"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_uno_7"
                    vid="estanque_uno_7"

                >
                  <b-form-input
                      id="estanque_uno_7"
                      v-model="estanque_uno_7"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_uno_7"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=7 && ciclos_riego<8)">
              <b-form-group
                  label="VII-Estanque 2"
                  label-for="estanque_dos_7"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_dos_7"
                    vid="estanque_dos_7"

                >
                  <b-form-input
                      id="estanque_dos_7"
                      v-model="estanque_dos_7"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_dos_7"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=7 && ciclos_riego<8)">
              <b-form-group
                  label="VII-Estanque 3"
                  label-for="estanque_tres_7"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_tres_7"
                    vid="estanque_tres_7"

                >
                  <b-form-input
                      id="estanque_tres_7"
                      v-model="estanque_tres_7"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_tres_7"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="(ciclos_riego>=7 && ciclos_riego<8)">
              <b-form-group
                  label="VII-Hora de Inicio"
                  label-for="hora_inicio_7"
              >
                <validation-provider
                    #default="{ errors }"
                    name="hora_inicio_7"
                    vid="hora_inicio_7"

                >
                  <b-form-timepicker
                      id="hora_inicio_7"
                      v-model="hora_inicio_7"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Comentarios"
                  label-for="comentarios"
              >
                <validation-provider
                    #default="{ errors }"
                    name="comentarios"
                    vid="comentarios"

                >
                  <b-form-input
                      id="comentarios"
                      v-model="comentarios"
                      :state="errors.length > 0 ? false:null"
                      name="comentarios"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!---------------12va fila-----------f-->

          <!---------------13va fila-----------i-->
          <b-row>
            <b-col lg="12">
              <b-alert
                  variant="danger"
                  class="mb-0"
                  :show="mostrarAlert"
              >
                <div class="alert-body">
                  <feather-icon
                      icon="InfoIcon"
                      class="mr-50"
                  />
                  La suma total de días, excede o es menor que el total máximo permitido.
                </div>
              </b-alert>
            </b-col>
            <b-col lg="12">
              <b-alert
                  variant="danger"
                  class="mb-0"
                  :show="mostrarAlert2"
              >
                <div class="alert-body">
                  <feather-icon
                      icon="InfoIcon"
                      class="mr-50"
                  />
                  Se han colocado valores en más días de los ingresados.
                </div>
              </b-alert>
            </b-col>
          </b-row>
          <!---------------13va fila-----------f-->
        </b-form>
      </validation-observer>
    </b-modal>


    <!-----------------------MODAL EDITAR REGITRO----------------------->
    <b-modal
        id="modal-editar"
        ref="modal-editar"
        v-model="estadoModalEditar"
        title="Editar Registro"
        ok-title="Editar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        :size="loadingEDI ? 'md':'xl'"
        :cancel-disabled="loadingEDI"
        :ok-disabled="loadingEDI"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden="resetModal"
        @ok="validarRegistroEditar"
    >
      <div v-if="loading2"  align="center">
        <p>Editando ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioEditarRiego" #default="{invalid}">
        <b-form autocomplete="off" @submit.prevent="editarRegistro">
          <!--------------1era fila------------i-->
          <b-row>
            <b-col lg="2">
              <b-form-group
                  label="Semana"
                  label-for="semana_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Semana"
                    vid="semana_e"
                    rules="required|integer|between:1,52"
                >
                  <b-form-input
                      id="semana_e"
                      v-model="semana"
                      :state="errors.length > 0 ? false:null"
                      name="semana"
                      @input="asignarInicioFinSemana"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                  label="Empresa"
                  label-for="empresa_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Empresa"
                    vid="empresa_e"
                    rules="required"
                >
                  <v-select
                      id="empresa_e"
                      v-model="empresa"
                      :options="empresas"
                      placeholder="Seleccionar empresa..."
                      @input="asignarCultivos"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Cultivo"
                  label-for="cultivo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Cultivo"
                    vid="cultivo_e"
                    rules="required"
                >
                  <v-select
                      id="cultivo_e"
                      v-model="cultivo"
                      :options="cultivos"
                      placeholder="Seleccionar cultivo..."
                      @input="asignarFundos"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                  label="Fundo"
                  label-for="fundo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Fundo"
                    vid="fundo_e"
                    rules="required"
                >
                  <v-select
                      id="fundo_e"
                      v-model="fundo"
                      :options="fundos"
                      placeholder="Seleccionar fundo..."
                      @input="asignarEtapas"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!--------------1era fila------------f-->

          <!--------------2da fila-------------i-->
          <b-row>
            <b-col lg="3">
              <b-form-group
                  label="Etapa"
                  label-for="etapa_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Etapa"
                    vid="etapa_e"
                    rules="required"
                >
                  <v-select
                      id="etapa_e"
                      v-model="etapa"
                      :options="etapas"
                      placeholder="Seleccionar etapa..."
                      @input="asignarCampos"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Campo"
                  label-for="campo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Campo"
                    vid="campo_e"
                    rules="required"
                >
                  <v-select
                      id="campo_e"
                      v-model="campo"
                      :options="campos"
                      placeholder="Seleccionar campo..."
                      @input="asignarTurnos"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Turno"
                  label-for="turno_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Turno"
                    vid="turno_e"
                    rules="required"
                >
                  <v-select
                      id="turno_e"
                      v-model="turno"
                      :options="turnos"
                      placeholder="Seleccionar turno..."
                      @input="asignarCodigos"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                  label="Codigo Homologado"
                  label-for="codigo_h_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Codigo Homologado"
                    vid="codigo_h_e"
                    rules="required"
                >
                  <v-select
                      id="codigo_h_e"
                      v-model="codigo_h"
                      :options="codigos_h"
                      :reduce="codigos_h => codigos_h.data"
                      label="codigo_h"
                      key="data"
                      placeholder="Seleccionar codigo..."
                      @input="seleccionarCodigoN"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!--------------2da fila-------------f-->

          <!--------------3ra fila-------------i-->
          <b-row>
            <b-col lg="3">
              <b-form-group
                  label="Variedad"
                  label-for="variedad_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Variedad"
                    vid="variedad_e"
                    rules="required"
                >
                  <b-form-input
                      id="variedad_e"
                      v-model="variedad"
                      :state="errors.length > 0 ? false:null"
                      name="variedad"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Lote"
                  label-for="lote_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Lote"
                    vid="lote_e"
                    rules="required"
                >
                  <b-form-input
                      id="lote_e"
                      v-model="lote"
                      :state="errors.length > 0 ? false:null"
                      name="lote"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Valvula"
                  label-for="valvula_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Valvula"
                    vid="valvula_e"
                    rules="required"
                >
                  <b-form-input
                      id="valvula_e"
                      v-model="valvula"
                      :state="errors.length > 0 ? false:null"
                      name="valvula"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Área"
                  label-for="area_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Área"
                    vid="area_e"
                    rules="required"
                >
                  <b-form-input
                      id="area_e"
                      v-model="area"
                      :state="errors.length > 0 ? false:null"
                      name="area"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!--------------3ra fila-------------f-->

          <!--------------4ta fila-------------i-->
          <b-row>
            <b-col lg="3">
              <b-form-group
                  label="ETO"
                  label-for="eto_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Eto"
                    vid="eto_e"
                    rules="required"
                >
                  <b-form-input
                      id="eto_e"
                      v-model="eto"
                      :state="errors.length > 0 ? false:null"
                      name="eto"
                      @input="calcularLrDia"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                  label="KC"
                  label-for="kc_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Kc"
                    vid="kc_e"
                    rules="required"
                >
                  <b-form-input
                      id="kc_e"
                      v-model="kc"
                      :state="errors.length > 0 ? false:null"
                      name="kc"
                      @input="calcularLrDia"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                  label="LR/Día"
                  label-for="lr_dia_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="lr_dia"
                    vid="lr_dia_e"
                    rules="required"
                >
                  <b-form-input
                      id="lr_dia_e"
                      v-model="lr_dia"
                      :state="errors.length > 0 ? false:null"
                      name="lr_dia"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                  label="Descarga Caudal/Hora (m3/Ha)"
                  label-for="descarga_caudal_hora_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="descarga_caudal_hora"
                    vid="descarga_caudal_hora_e"
                    rules="required"
                >
                  <b-form-input
                      id="descarga_caudal_hora_e"
                      v-model="descarga_caudal_hora"
                      :state="errors.length > 0 ? false:null"
                      name="descarga_caudal_hora"
                      @input="calcularLrDia"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!--------------4ta fila-------------f-->

          <!--------------5ta fila-------------i-->
          <b-row>
            <b-col lg="2">
              <b-form-group
                  label="Volumen Total/Dia/Turno"
                  label-for="volumen_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Volumen"
                    vid="volumen_e"
                    rules="required"

                >
                  <b-form-input
                      id="volumen_e"
                      v-model="volumen"
                      :state="errors.length > 0 ? false:null"
                      name="volumen"
                      @input="calcularLrDia"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Ciclos de Riego"
                  label-for="ciclo_riego_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="ciclos_riego"
                    vid="ciclos_riego_e"
                    rules="required"

                >
                  <b-form-input
                      id="ciclos_riego_e"
                      v-model="ciclos_riego"
                      :state="errors.length > 0 ? false:null"
                      name="ciclos_riego"
                      @input="calcularLrDia"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Riego Total (m3/Ha)"
                  label-for="riego_total_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Riego_total"
                    vid="riego_total_e"
                    rules="required"
                >
                  <b-form-input
                      id="riego_total_e"
                      v-model="riego_total"
                      :state="errors.length > 0 ? false:null"
                      name="riego_total"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Horas"
                  label-for="horas_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="horas"
                    vid="horas_e"
                    rules="required"
                >
                  <b-form-input
                      id="horas_e"
                      v-model="horas"
                      :state="errors.length > 0 ? false:null"
                      name="horas"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Riego Cortina"
                  label-for="riego_cortina_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Riego_cortina"
                    vid="riego_cortina_e"
                    rules="required"
                >
                  <b-form-input
                      id="riego_cortina_e"
                      v-model="riego_cortina"
                      :state="errors.length > 0 ? false:null"
                      name="riego_cortina"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Con/Sin Fertilizante"
                  label-for="con_sin_fertilizante_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="con_sin_fertilizante"
                    vid="con_sin_fertilizante_e"
                    rules="required"
                >
                  <v-select
                      id="con_sin_fertilizante_e"
                      v-model="con_sin_fertilizante"
                      :options="con_sin_fertilizantes"
                      :reduce="con_sin_fertilizantes => con_sin_fertilizantes.value"
                      label="text"
                      key="value"
                      placeholder="Seleccionar..."
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!--------------5ta fila-------------f-->

          <!---------------6ta fila------------f-->
          <b-row>
            <b-col lg="2">
              <b-form-group
                  label="Ciclo I (m3)"
                  label-for="ciclo_1_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="ciclo_1"
                    vid="ciclo_1_e"
                    rules="required"
                >
                  <b-form-input
                      id="ciclo_1_e"
                      v-model="ciclo_1"
                      :state="errors.length > 0 ? false:null"
                      name="ciclo_1"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="I-Estanque 1"
                  label-for="estanque_uno_1_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_uno_1"
                    vid="estanque_uno_1_e"
                    rules="required"
                >
                  <b-form-input
                      id="estanque_uno_1_e"
                      v-model="estanque_uno_1"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_uno_1"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="I-Estanque 2"
                  label-for="estanque_dos_1_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_dos_1"
                    vid="estanque_dos_1_e"
                    rules="required"
                >
                  <b-form-input
                      id="estanque_dos_1_e"
                      v-model="estanque_dos_1"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_dos_1"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="I-Estanque 3"
                  label-for="estanque_tres_1_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_tres_1"
                    vid="estanque_tres_1_e"
                    rules="required"
                >
                  <b-form-input
                      id="estanque_tres_1_e"
                      v-model="estanque_tres_1"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_tres_1"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="I-Hora de Inicio"
                  label-for="hora_inicio_1_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="hora_inicio_1"
                    vid="hora_inicio_1_e"
                    rules="required"
                >
                  <b-form-timepicker
                      id="hora_inicio_1_e"
                      v-model="hora_inicio_1"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Horas para inicio Segundo Ciclo"
                  label-for="horas_inicio_seg_ciclo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="horas_inicio_seg_ciclo"
                    vid="horas_inicio_seg_ciclo_e"

                >
                  <b-form-input
                      id="horas_inicio_seg_ciclo_e"
                      v-model="horas_inicio_seg_ciclo"
                      :state="errors.length > 0 ? false:null"
                      name="horas_inicio_seg_ciclo"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!---------------6ta fila------------f-->

          <!---------------7ma fila------------i-->
          <b-row>
            <b-col lg="2">
              <b-form-group
                  label="Ciclo II (m3)"
                  label-for="ciclo_2_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="ciclo_2"
                    vid="ciclo_2_e"

                >
                  <b-form-input
                      id="ciclo_2_e"
                      v-model="ciclo_2"
                      :state="errors.length > 0 ? false:null"
                      name="ciclo_2"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="II-Estanque 1"
                  label-for="estanque_uno_2_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_uno_2"
                    vid="estanque_uno_2_e"

                >
                  <b-form-input
                      id="estanque_uno_2_e"
                      v-model="estanque_uno_2"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_uno_2"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="II-Estanque 2"
                  label-for="estanque_dos_2_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_dos_2"
                    vid="estanque_dos_2_e"

                >
                  <b-form-input
                      id="estanque_dos_2_e"
                      v-model="estanque_dos_2"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_dos_2"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="II-Estanque 3"
                  label-for="estanque_tres_2_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_tres_2"
                    vid="estanque_tres_2_e"

                >
                  <b-form-input
                      id="estanque_tres_2_e"
                      v-model="estanque_tres_2"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_tres_2"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="II-Hora de Inicio"
                  label-for="hora_inicio_2_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="hora_inicio_2"
                    vid="hora_inicio_2_e"

                >
                  <b-form-timepicker
                      id="hora_inicio_2_e"
                      v-model="hora_inicio_2"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Horas para inicio Tercer Ciclo"
                  label-for="horas_inicio_ter_ciclo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="horas_inicio_ter_ciclo"
                    vid="horas_inicio_ter_ciclo_e"

                >
                  <b-form-input
                      id="horas_inicio_ter_ciclo_e"
                      v-model="horas_inicio_ter_ciclo"
                      :state="errors.length > 0 ? false:null"
                      name="horas_inicio_ter_ciclo"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!---------------7ma fila------------f-->

          <!---------------8va fila------------i-->
          <b-row>
            <b-col lg="2">
              <b-form-group
                  label="Ciclo III (m3)"
                  label-for="ciclo_3_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="ciclo_3"
                    vid="ciclo_3_e"

                >
                  <b-form-input
                      id="ciclo_3_e"
                      v-model="ciclo_3"
                      :state="errors.length > 0 ? false:null"
                      name="ciclo_3"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="III-Estanque 1"
                  label-for="estanque_uno_3_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_uno_3"
                    vid="estanque_uno_3_e"

                >
                  <b-form-input
                      id="estanque_uno_3_e"
                      v-model="estanque_uno_3"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_uno_3"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="III-Estanque 2"
                  label-for="estanque_dos_3_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_dos_3"
                    vid="estanque_dos_3_e"

                >
                  <b-form-input
                      id="estanque_dos_3_e"
                      v-model="estanque_dos_3"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_dos_3"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="III-Estanque 3"
                  label-for="estanque_tres_3_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_tres_3"
                    vid="estanque_tres_3_e"

                >
                  <b-form-input
                      id="estanque_tres_3_e"
                      v-model="estanque_tres_3"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_tres_3"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="III-Hora de Inicio"
                  label-for="hora_inicio_3_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="hora_inicio_3"
                    vid="hora_inicio_3_e"

                >
                  <b-form-timepicker
                      id="hora_inicio_3_e"
                      v-model="hora_inicio_3"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Horas para inicio Cuarto Ciclo"
                  label-for="horas_inicio_cuarto_ciclo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="horas_inicio_cuarto_ciclo"
                    vid="horas_inicio_cuarto_ciclo_e"

                >
                  <b-form-input
                      id="horas_inicio_cuarto_ciclo_e"
                      v-model="horas_inicio_cuarto_ciclo"
                      :state="errors.length > 0 ? false:null"
                      name="horas_inicio_cuarto_ciclo"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!---------------8va fila------------f-->

          <!---------------9na fila------------i-->
          <b-row>
            <b-col lg="2">
              <b-form-group
                  label="Ciclo IV (m3)"
                  label-for="ciclo_4_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="ciclo_4"
                    vid="ciclo_4_e"

                >
                  <b-form-input
                      id="ciclo_4_e"
                      v-model="ciclo_4"
                      :state="errors.length > 0 ? false:null"
                      name="ciclo_4"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="IV-Estanque 1"
                  label-for="estanque_uno_4_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_uno_4"
                    vid="estanque_uno_4_e"

                >
                  <b-form-input
                      id="estanque_uno_4_e"
                      v-model="estanque_uno_4"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_uno_4"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="IV-Estanque 2"
                  label-for="estanque_dos_4_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_dos_4"
                    vid="estanque_dos_4_e"

                >
                  <b-form-input
                      id="estanque_dos_4_e"
                      v-model="estanque_dos_4"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_dos_4"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="IV-Estanque 3"
                  label-for="estanque_tres_4_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_tres_4"
                    vid="estanque_tres_4_e"

                >
                  <b-form-input
                      id="estanque_tres_4_e"
                      v-model="estanque_tres_4"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_tres_4"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="IV-Hora de Inicio"
                  label-for="hora_inicio_4_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="hora_inicio_4"
                    vid="hora_inicio_4_e"

                >
                  <b-form-timepicker
                      id="hora_inicio_4_e"
                      v-model="hora_inicio_4"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Horas para inicio Quinto Ciclo"
                  label-for="horas_inicio_quinto_ciclo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="horas_inicio_quinto_ciclo"
                    vid="horas_inicio_quinto_ciclo_e"

                >
                  <b-form-input
                      id="horas_inicio_quinto_ciclo_e"
                      v-model="horas_inicio_quinto_ciclo"
                      :state="errors.length > 0 ? false:null"
                      name="horas_inicio_quinto_ciclo"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!---------------9na fila------------f-->

          <!---------------10ma fila-----------i-->
          <b-row>
            <b-col lg="2">
              <b-form-group
                  label="Ciclo V (m3)"
                  label-for="ciclo_5_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="ciclo_5"
                    vid="ciclo_5_e"

                >
                  <b-form-input
                      id="ciclo_5_e"
                      v-model="ciclo_5"
                      :state="errors.length > 0 ? false:null"
                      name="ciclo_5"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="V-Estanque 1"
                  label-for="estanque_uno_5_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_uno_5"
                    vid="estanque_uno_5_e"

                >
                  <b-form-input
                      id="estanque_uno_5_e"
                      v-model="estanque_uno_5"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_uno_5"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="V-Estanque 2"
                  label-for="estanque_dos_5_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_dos_5"
                    vid="estanque_dos_5_e"

                >
                  <b-form-input
                      id="estanque_dos_5_e"
                      v-model="estanque_dos_5"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_dos_5"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="V-Estanque 3"
                  label-for="estanque_tres_5_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_tres_5"
                    vid="estanque_tres_5_e"

                >
                  <b-form-input
                      id="estanque_tres_5_e"
                      v-model="estanque_tres_5"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_tres_5"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="V-Hora de Inicio"
                  label-for="hora_inicio_5_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="hora_inicio_5"
                    vid="hora_inicio_5_e"

                >
                  <b-form-timepicker
                      id="hora_inicio_5_e"
                      v-model="hora_inicio_5"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Horas para inicio Sexto Ciclo"
                  label-for="horas_inicio_sexto_ciclo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="horas_inicio_sexto_ciclo"
                    vid="horas_inicio_sexto_ciclo_e"

                >
                  <b-form-input
                      id="horas_inicio_sexto_ciclo_e"
                      v-model="horas_inicio_sexto_ciclo"
                      :state="errors.length > 0 ? false:null"
                      name="horas_inicio_sexto_ciclo"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!---------------10ma fila-----------f-->

          <!---------------11va fila-----------i-->
          <b-row>
            <b-col lg="2">
              <b-form-group
                  label="Ciclo VI (m3)"
                  label-for="ciclo_6_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="ciclo_6"
                    vid="ciclo_6_e"

                >
                  <b-form-input
                      id="ciclo_6_e"
                      v-model="ciclo_6"
                      :state="errors.length > 0 ? false:null"
                      name="ciclo_6"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="VI-Estanque 1"
                  label-for="estanque_uno_6_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_uno_6"
                    vid="estanque_uno_6_e"

                >
                  <b-form-input
                      id="estanque_uno_6_e"
                      v-model="estanque_uno_6"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_uno_6"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="VI-Estanque 2"
                  label-for="estanque_dos_6_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_dos_6"
                    vid="estanque_dos_6_e"

                >
                  <b-form-input
                      id="estanque_dos_6_e"
                      v-model="estanque_dos_6"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_dos_6"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="VI-Estanque 3"
                  label-for="estanque_tres_6_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_tres_6"
                    vid="estanque_tres_6_e"

                >
                  <b-form-input
                      id="estanque_tres_6_e"
                      v-model="estanque_tres_6"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_tres_6"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="VI-Hora de Inicio"
                  label-for="hora_inicio_6_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="hora_inicio_6"
                    vid="hora_inicio_6_e"

                >
                  <b-form-timepicker
                      id="hora_inicio_6_e"
                      v-model="hora_inicio_6"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Horas para inicio Septimo Ciclo"
                  label-for="horas_inicio_septimo_ciclo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="horas_inicio_septimo_ciclo"
                    vid="horas_inicio_septimo_ciclo_e"

                >
                  <b-form-input
                      id="horas_inicio_septimo_ciclo_e"
                      v-model="horas_inicio_septimo_ciclo"
                      :state="errors.length > 0 ? false:null"
                      name="horas_inicio_septimo_ciclo"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!---------------11va fila-----------f-->

          <!---------------12va fila-----------i-->
          <b-row>
            <b-col lg="2">
              <b-form-group
                  label="Ciclo VII (m3)"
                  label-for="ciclo_7_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="ciclo_7"
                    vid="ciclo_7_e"

                >
                  <b-form-input
                      id="ciclo_7_e"
                      v-model="ciclo_7"
                      :state="errors.length > 0 ? false:null"
                      name="ciclo_7"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="VII-Estanque 1"
                  label-for="estanque_uno_7_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_uno_7"
                    vid="estanque_uno_7_e"

                >
                  <b-form-input
                      id="estanque_uno_7_e"
                      v-model="estanque_uno_7"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_uno_7"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="VII-Estanque 2"
                  label-for="estanque_dos_7_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_dos_7"
                    vid="estanque_dos_7_e"

                >
                  <b-form-input
                      id="estanque_dos_7_e"
                      v-model="estanque_dos_7"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_dos_7"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="VII-Estanque 3"
                  label-for="estanque_tres_7_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estanque_tres_7"
                    vid="estanque_tres_7_e"

                >
                  <b-form-input
                      id="estanque_tres_7_e"
                      v-model="estanque_tres_7"
                      :state="errors.length > 0 ? false:null"
                      name="estanque_tres_7"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="VII-Hora de Inicio"
                  label-for="hora_inicio_7_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="hora_inicio_7"
                    vid="hora_inicio_7_e"

                >
                  <b-form-timepicker
                      id="hora_inicio_7_e"
                      v-model="hora_inicio_7"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Comentarios"
                  label-for="comentarios_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="comentarios"
                    vid="comentarios_e"

                >
                  <b-form-input
                      id="comentarios_e"
                      v-model="comentarios"
                      :state="errors.length > 0 ? false:null"
                      name="comentarios"

                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

          </b-row>
          <!---------------12va fila-----------f-->

        </b-form>
      </validation-observer>
    </b-modal>

    <!-----------------------MODAL IMPORTAR MASIVO---------------------->
    <b-modal
        id="modal-importar"
        ref="modal-importar"
        v-model="estadoModalImportar"
        title="Importar Datos Masivos"
        ok-title="Importar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        size="md"
        :cancel-disabled="loadingIMP"
        :ok-disabled="loadingIMP||!archivo_excel"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden=""
        @ok="importarOk"
    >
      <div v-if="loadingIMP"  align="center">
        <p>Importando datos ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioImportar" #default="{invalid}">
        <b-form autocomplete="off" @submit.prevent="enviarFile">
          <b-row>
            <b-col lg="12">
              <b-form-group
                  label="Archivo"
                  label-for="archivo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Archivo"
                    vid="archivo"
                    rules="required"
                >
                  <b-form-file
                      id="archivo"
                      accept=".xlsx"
                      placeholder="Seleccionar Archivo Excel (.xlsx)"
                      v-model="archivo_excel"
                      ref="fileinput"
                  >
                    <template
                        slot="file-name"
                        slot-scope="{ names }"
                    >
                      <b-badge variant="primary">
                        {{ names[0] }}
                      </b-badge>
                    </template>
                  </b-form-file>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <!---------MODAL LISTADO ERRORES DESPUES DEL IMPORTAR MASIVO-------->
    <b-modal
        id="modal-respuesta"
        ref="modal-respuesta"
        v-model="mostrarErrores"
        title="Importación Fallida"
        ok-title="Aceptar"
        ok-only
        size="md"
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden=""
        scrollable
    >
      <b-row>
        <b-col lg="12">
          <span>Importante: No se hizo ningun registro debido a que
            la plantilla presenta errores en la siguientes filas:
          </span>
          <br>
          <div
              v-for="error in respuestaErrores"
              :key="error.contador2"
          >
            <div class="mb-1">
              <br>
              <span>Fila: {{ error.id }}</span><br>
              <span>Codigo homologado: {{ error.cod_homologado }}</span><br>
              <span>Error: {{ error.error }}.</span>
            </div>
          </div>

        </b-col>
      </b-row>
    </b-modal>

    <!---------MODAL LISTADO REGISTROS DESPUES DEL IMPORTAR MASIVO------>
    <b-modal
        id="modal-respuesta"
        ref="modal-respuesta"
        v-model="estadoModalRespuesta"
        title="Respuesta"
        ok-title="Aceptar"
        ok-only
        size="md"
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden=""
        scrollable
    >
      <b-row>
        <b-col lg="12">
          <span>Se realizó la creación de registros satisfactoriamente.</span>
          <div
              v-for="error in respuestaErrores"
              :key="error.contador2"
          >
            <div class="mb-1">
              <span>Codigo homologado: {{ error.cod_homologado }}</span><br>
              <span>Error: {{ error.error }}.</span>
            </div>
          </div>


        </b-col>
      </b-row>
    </b-modal>

    <!--------------------------MODAL EDITAR ESTADO--------------------->
    <b-modal
        id="modal-select2"
        v-model="modalEditarEstadoShow"
        no-close-on-esc
        no-close-on-backdrop
        cancel-variant="secondary"
        ok-title="Actualizar"
        :ok-disabled="!estado_aprobar"
        cancel-title="Cancelar"
        centered
        title="Autorizar registro"
        @ok="aprobar"
    >
      <b-form>
        <b-form-group
            label="Estado"
            label-for="estado_editar"
        >
          <v-select
              id="estado_editar"
              v-model="estado_aprobar"
              :options="estados"
              :reduce="estados => estados.value"
              label="text"
              key="value"
              placeholder="Seleccionar estado..."
          />
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>

import axiosIns from '../../libs/axios'
import vSelect from 'vue-select'
import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BModal,
  BPagination,
  BSpinner,
  BTable,
  BRow,
  BCol,
  BDropdownDivider,
  BFormFile,
  VBModal,
  BTooltip,
  BInputGroup,
  BFormDatepicker,
  BFormTimepicker,
  BInputGroupAppend,
  BInputGroupPrepend, BFormTextarea, BLink, BButtonGroup,
  BAlert, VBTooltip,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required, double, max, between, integer } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BFormInput,
    BModal,
    VBModal,
    BForm,
    BCol,
    BRow,
    BDropdownDivider,
    BFormFile,
    BTooltip,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormTextarea,
    BLink,
    BFormDatepicker,
    BFormTimepicker,
    BButtonGroup,
    BAlert,

    vSelect,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  data: () => ({
    id_user: JSON.parse(localStorage.getItem('userData')).id,
    inicioSemana: null,
    finSemana:null,
    fechaInicioSemana:null,
    fechaFinSemana:null,
    codigo_h:null,

    semana: null,
    fecha: null,
    fundo: null,
    cultivo: null,
    cultivoIMP: null,
    etapa: null,
    empresa: null,
    campo: null,
    turno: null,
    cod_homologado:null,

    variedad: null,
    lote: null,
    valvula: null,
    area: null,

    eto:null,
    kc:null,
    lr_dia:null,
    descarga_caudal_hora:null,

    volumen:null,
    ciclos_riego:null,
    riego_total:null,
    horas:null,
    riego_cortina:null,
    con_sin_fertilizante:null,

    ciclo_1:null,
    estanque_uno_1:null,
    estanque_dos_1:null,
    estanque_tres_1:null,
    hora_inicio_1:null,
    horas_inicio_seg_ciclo:null,

    ciclo_2:null,
    estanque_uno_2:null,
    estanque_dos_2:null,
    estanque_tres_2:null,
    hora_inicio_2:null,
    horas_inicio_ter_ciclo:null,

    ciclo_3:null,
    estanque_uno_3:null,
    estanque_dos_3:null,
    estanque_tres_3:null,
    hora_inicio_3:null,
    comentarios:null,

    title_sem: null,

    empresaFiltro: null,
    empresasFiltro: [],
    semanaFiltro: null,
    semanasFiltro: [],
    cultivoFiltro: null,
    cultivosFiltro: [],

    dias: null,


    indicador: null,

    submittedNames: [],
    loading: false,
    loading2: false,
    loadingBP: false,
    loadingDE: false,
    loadingIMP: false,
    loadingEDI: false,

    loadingSAC: false,
    loadingSSC: false,
    loadingSSM: false,
    loadingSAM: false,
    loadingSAD: false,
    loadingSSD: false,

    estadoModalEditar: false,
    estadoModalImportar: false,
    estadoModalRespuesta: false,
    mostrarErrores:false,
    errores_res_impor:'',
    modal_registro_o: false,

    modalEditarEstadoShow: false,
    items: [],
    items_completo: [],
    nuevo_items : [],
    perPage: 5,
    pageOptions: [5, 10, 15, 30],
    totalRows: 0,
    currentPage: 1,
    sortBy: 'id',
    sortDesc: true,
    sortDirection: 'desc',
    filter: null,
    filter_sig: null,
    filterOn: ['semana'],
    fields: [
      {
        key: 'acciones',
        label: '# ',
        class: 'text-nowrap text-center',
        stickyColumn: true,
      },
      {
        key: 'estado',
        label: 'estado',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'semana',
        label: 'semana',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'cultivo',
        label: 'cultivo',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'empresa',
        label: 'empresa',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      // {
      //   key: 'fundo',
      //   label: 'fundo',
      //   class: 'text-nowrap text-center',
      //   sortable: true,
      // },
      {
        key: 'version',
        label: 'version',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'created',
        label: 'Fecha - Hora',
        class: 'text-nowrap text-center',
        sortable: true,
      },


      /*
    {
      key: 'con_usuario.username',
      label: 'Usuario',
      class: 'text-nowrap text-center',
      sortable: true,
    },
      */
      // {
      //   key: 'created',
      //   label: 'Fecha - Hora',
      //   class: 'text-nowrap text-center',
      //   sortable: true,
      // },

    ],
    fields_detalle_SemAct: [
      {
        key: 'acciones',
        label: '# ',
        class: 'text-nowrap text-center',
      },
      {
        key: 'fecha',
        label: 'fecha',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'fundo',
        label: 'fundo',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estado',
        label: 'estado',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'etapa',
        label: 'etapa',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'campo',
        label: 'campo',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'turno',
        label: 'turno',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'variedad',
        label: 'variedad',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'lote',
        label: 'lote',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'valvula',
        label: 'válvula',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'area',
        label: 'área',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'eto',
        label: 'ETO',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'kc',
        label: 'KC',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'lr_dia',
        label: 'LR/Dia',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'descarga_caudal_hora',
        label: 'Descarga Caudal/Hora (m3/Ha)',
        class: 'text-nowrap text-center',
        sortable: true,
      },

      {
        key: 'volumen',
        label: 'Volumen Total/Dia/Turno',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'ciclos_riego',
        label: 'Ciclos de Riego',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'riego_total',
        label: 'Riego Total',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'horas',
        label: 'Horas',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'riego_cortina',
        label: 'Riego Cortina',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'con_sin_fertilizante',
        label: 'Con/Sin Fertilizante',
        class: 'text-nowrap text-center',
        sortable: true,
      },

      {
        key: 'ciclo_1',
        label: 'Ciclo I',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_uno_1',
        label: 'Estanque 1',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_dos_1',
        label: 'Estanque 2',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_tres_1',
        label: 'Estanque 3',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'hora_inicio_1',
        label: 'Hora de Inicio',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'horas_inicio_seg_ciclo',
        label: 'Horas para Inicio de 2° Ciclo',
        class: 'text-nowrap text-center',
        sortable: true,
      },

      {
        key: 'ciclo_2',
        label: 'Ciclo II',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_uno_2',
        label: 'Estanque 1',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_dos_2',
        label: 'Estanque 2',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_tres_2',
        label: 'Estanque 3',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'hora_inicio_2',
        label: 'Hora de Inicio',
        class: 'text-nowrap text-center',
        sortable: true,
      },

      {
        key: 'horas_inicio_ter_ciclo',
        label: 'Horas para Inicio de 3° Ciclo',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'ciclo_3',
        label: 'Ciclo III',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_uno_3',
        label: 'Estanque 1',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_dos_3',
        label: 'Estanque 2',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_tres_3',
        label: 'Estanque 3',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'hora_inicio_3',
        label: 'Hora de Inicio',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      // -----------------------
      {
        key: 'horas_inicio_cuarto_ciclo',
        label: 'Horas para Inicio de 4° Ciclo',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'ciclo_4',
        label: 'Ciclo IV',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_uno_4',
        label: 'Estanque 1',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_dos_4',
        label: 'Estanque 2',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_tres_4',
        label: 'Estanque 3',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'hora_inicio_4',
        label: 'Hora de Inicio',
        class: 'text-nowrap text-center',
        sortable: true,
      },


      {
        key: 'horas_inicio_quinto_ciclo',
        label: 'Horas para Inicio de 5° Ciclo',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'ciclo_5',
        label: 'Ciclo V',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_uno_5',
        label: 'Estanque 1',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_dos_5',
        label: 'Estanque 2',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_tres_5',
        label: 'Estanque 3',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'hora_inicio_5',
        label: 'Hora de Inicio',
        class: 'text-nowrap text-center',
        sortable: true,
      },


      {
        key: 'horas_inicio_sexto_ciclo',
        label: 'Horas para Inicio de 6° Ciclo',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'ciclo_6',
        label: 'Ciclo VI',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_uno_6',
        label: 'Estanque 1',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_dos_6',
        label: 'Estanque 2',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_tres_6',
        label: 'Estanque 3',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'hora_inicio_6',
        label: 'Hora de Inicio',
        class: 'text-nowrap text-center',
        sortable: true,
      },


      {
        key: 'horas_inicio_septimo_ciclo',
        label: 'Horas para Inicio de 7° Ciclo',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'ciclo_7',
        label: 'Ciclo VII',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_uno_7',
        label: 'Estanque 1',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_dos_7',
        label: 'Estanque 2',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_tres_7',
        label: 'Estanque 3',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'hora_inicio_7',
        label: 'Hora de Inicio',
        class: 'text-nowrap text-center',
        sortable: true,
      },

      // -----------------
      {
        key: 'comentarios',
        label: 'Comentarios',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'cod_homologado',
        label: 'Cod.  Homologado',
        class: 'text-nowrap text-center',
        sortable: true,
      },



      /*
    {
      key: 'created',
      label: 'Fecha - Hora',
      class: 'text-nowrap text-center',
      sortable: true,
    },
      */
    ],

    espanol:{
      labelNoTimeSelected: 'Seleccione Hora',
    },

    status: [
      {
        0: 'Pendiente',
        1: 'Revisado',
        2: 'Aprobado',
        3: 'Desaprobado',
        4: 'Eliminado',
        5: 'Conforme'
      },
      {
        0: 'light-info',
        1: 'light-warning',
        2: 'light-success',
        3: 'light-danger',
        4: 'light-dark',
        5: 'light-primary',
      }
    ],

    con_sin_fertilizantes:[
      {value:'SI',text:'SI'},
      {value:'NO',text:'NO'}
    ],

    estados: [
      {value: '1', text: "Dar visto bueno"},
      /*
      {value: '1', text: "Observar"},
      {value: '3', text: "Desaprobar"}
       */
    ],

    estados_lotes: [
      { value: '0', text: "Activo" },
      { value: '1', text: "Agrupado" },
      { value: '2', text: "Pendiente" },
    ],

    parametros_usuario: [],

    estado_aprobar: null,
    estado_lote: null,
    codigos_h_resp : [],

    archivo_excel: null,
    empresas: [],
    cultivos: [],
    cultivosIMP: ['ARANDANO', 'ESPARRAGO', 'PALTA', 'UVA'],
    fundos: [],
    etapas: [],
    campos: [],
    turnos: [],
    codigos_h: [],
    parametros: [],

    dataEmpresa: [],
    dataLotesValvulas: [],
    notDuplicados: [],
    dataCompleta: [],

    spd: [],
    dia: null,
    hora: null,
    // -------

    comentario: null,

    semana_sig: null,
    inicioSemana_sig: null,
    finSemana_sig: null,

    mostrarSemAct: false,
    mostrarSemSgte: false,
    items_sem_act: [],
    items_sem_sgte: [],
    responsable: [],

    dataAutorizar:null,

    semanaActual: true,
    semanaEnviar: null,

    mostrarAlert: false,
    mostrarAlert2: false,

    respuestaRegistrosTotal: 0,
    respuestaErrores: [],

    // validation rules
    required,
    double,
    max,
    between,
    integer,
  }),
  computed: {},
  async mounted() {
    await this.buscarResponsable(); // Obtiene la información si el usuario que inició sesion tiene permisos para ver, editar, etc.
    await this.dataInicial(); // Obtiene información sobre el numero de semana actual y la sgte
    await this.traerDataEmpresa(); // Obtiene la información del area por codigo homologado de ambas empresas(AGV,ARV)
    await this.traerRiegos(); // Trae lo registrado de la tabla pag_riego en base a la semana actual y la sgte.
    await this.asignarCultivos(); // Segun la empresa asigna los cultivos asignados a ella en el select
    // await this.traerDataLotesValvulas();
    localize("es");
  },
  methods: {
    convertirMesANumero(mes) {
      if( mes === 'setiembre'){
        mes = 'septiembre'
      }
      const meses = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
      return meses.indexOf(mes.toLowerCase()) + 1; // Sumar 1 porque los meses van de 1 a 12
    },

    dataInicial(){
      const yo = this
      // this.semana = "49";
      // this.semana_sig = "50";
      const spd = this.numeroDeSemana(new Date())
      this.semana = spd.n_semana.toString().padStart(2, '0')
      this.inicioSemana = spd.inicio.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })
      this.finSemana = spd.fin.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })

      this.semana_sig = spd.n_semana === 52 ? '01' : (spd.n_semana + 1).toString().padStart(2, '0')
      // this.semana_sig = spd.n_semana + 1
      spd.inicio.setDate(spd.inicio.getDate() + 7)
      spd.fin.setDate(spd.fin.getDate() + 7)

      this.inicioSemana_sig = spd.inicio.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })
      this.finSemana_sig = spd.fin.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })

      // this.inicioSemana = "2 de diciembre de 2024";
      // this.finSemana = "8 de diciembre de 2024";
      // this.inicioSemana_sig = "9 de diciembre de 2024";
      // this.finSemana_sig = "15 de diciembre de 2024";
      // this.anio = "2024";

      this.filter = this.semana
      this.filter_sig = this.semana_sig

    },

    traerRiegos(){
      const yo = this
      yo.loading = true

      const config = {
        method: 'get',
        url: '/pagricolas/riego/'
      }

      axiosIns(config)
          .then(function (response) {

            if(response.status === 200){
              yo.items_completo = response.data;
              yo.items = response.data;
              yo.spd = response.data;
              yo.totalRows = yo.items.length

              console.log(yo.items)

              let ultimasVersiones = {};
              yo.items.forEach(item => {
                  let cultivo = item.cultivo;
                  let empresa = item.empresa;
                  let semana = item.semana;
                  let version = parseInt(item.version, 10); // Convertir la versión a número
                  let clave = cultivo + '-' + empresa + '-' + semana;
                  if (ultimasVersiones[clave]) {
                      if (version > parseInt(ultimasVersiones[clave].version, 10)) {
                          ultimasVersiones[clave] = item;
                      }
                  } else {
                      ultimasVersiones[clave] = item;
                  }
              });
              let ultimasVersionesArray = Object.values(ultimasVersiones);

              yo.items = ultimasVersionesArray

              console.log(yo.items)

              yo.empresasFiltro = []
              yo.semanasFiltro = []
              yo.cultivosFiltro = []
              yo.notDuplicados = []
              const arr = []
              let val = ''

              let sumL = 0
              let sumKG = 0
              let indice = 0
              let c = 0

              for (let valor of yo.items){
                yo.empresasFiltro.push(valor.empresa)
                yo.semanasFiltro.push(valor.semana)
                yo.cultivosFiltro.push(valor.cultivo)
                // yo.notDuplicados.push(valor.semana+valor.cultivo+valor.empresa+valor.fundo)
                // yo.notDuplicados.push(valor.semana+valor.cultivo+valor.empresa)

                // if(val!==valor.semana+valor.cultivo+valor.empresa+valor.fundo){
                if(val!==valor.semana+valor.cultivo+valor.empresa){
                  arr.push(valor)
                  // if(indice!==0){
                  //   arr[indice-1].etapa_fen = sumL.toFixed(3) + ' L - ' + sumKG.toFixed(3) + ' KG'
                  // }
                  // sumL = 0
                  // sumKG = 0
                  // indice ++
                }


                // val = valor.semana+valor.cultivo+valor.empresa+valor.fundo
                val = valor.semana+valor.cultivo+valor.empresa
                // c++

                // if(c===yo.items.length){
                //   arr[indice-1].etapa_fen = sumL.toFixed(3) + ' L / ' + sumKG.toFixed(3) + ' KG'
                // }
              }

              // console.log("array")
              // console.log(arr)

              yo.empresasFiltro = [... new Set(yo.empresasFiltro)];
              yo.semanasFiltro = [... new Set(yo.semanasFiltro)];
              yo.cultivosFiltro = [... new Set(yo.cultivosFiltro)];
              yo.notDuplicados = [... new Set(yo.notDuplicados)];

              yo.items = arr
              // console.log(yo.items)

              // console.log("YA FILTRANDO EMPRESA Y CULTIVO:")
              // console.log(yo.items)

              //Valido por Empresa
              if(yo.responsable[0].empresa !== 'TODOS'){ // Se asume que es AGV o ARV, nunca ambos. Y si fuera el caso sería 'TODOS'
                  yo.items = yo.items.filter(
                    invoice => invoice.empresa === yo.responsable[0].empresa
                  )
              }

              //Valido por Cultivo
              if(yo.responsable[0].cultivo !== 'TODOS'){
                //Filtro utilizando el include asumiendo que en algunos casos solo sera 01 cultivo y en otros seran varios.
                yo.items = yo.items.filter(
                  invoice => yo.responsable[0].cultivo.includes(invoice.cultivo)
                )

              }

              //Valido por Rol
              if(yo.responsable[0].rol === 'USUARIO'){
                yo.estados = [
                  {value: '1', text: "Dar visto bueno"},
                  {value: '4', text: "Eliminar"}
                ]
              }else if(yo.responsable[0].rol === 'JEFE DE RIEGO'){
                yo.estados = [
                  {value: '2', text: "Aprobar"},
                  {value: '3', text: "Desaprobar"}
                ]

                yo.items = yo.items.filter(
                  invoice => invoice.estado !== '0' //Si es jefe de riego no debería ver pendientes, solo Revisados
                )
              }else if(yo.responsable[0].rol === 'JEFE DE RIEGO CORPORATIVO'){
                yo.estados = [
                  {value: '5', text: "Dar Conformidad"}
                ]
                yo.items = yo.items.filter(
                  invoice => invoice.estado === '2' || invoice.estado === '5' //Si es jefe corporativo solo debería ver Aprobados y Conformes
                )
              }else if(yo.responsable[0].rol === 'ADMINISTRADOR'){
                yo.estados = [
                  {value: '1', text: "Dar visto bueno"},
                  {value: '2', text: "Aprobar"},
                  {value: '3', text: "Desaprobar"},
                  {value: '4', text: "Eliminar"},
                  {value: '5', text: "Dar Conformidad"}
                ]
              }

              // console.log("YA FILTRANDO ROL:")
              // console.log(yo.items)

              //// ANTIGUA VALIDACIÓN
              // if(yo.responsable[0].rol === 'JEFE DE RIEGO'){
              //   console.log("Es rol JEFE DE RIEGO")
              //   yo.estados = [
              //     {value: '2', text: "Aprobar"},
              //     {value: '3', text: "Desaprobar"}
              //   ]

              //   yo.items = yo.items.filter(
              //       invoice => invoice.empresa === yo.responsable[0].empresa && invoice.estado !== '0' //Si es jefe de riego no debería ver pendientes
              //   )

              //   console.log(yo.items)

              // }else if(yo.responsable[0].rol === 'USUARIO'){
              //   console.log("Es rol USUARIO")
              //   if(yo.responsable[0].empresa === 'TODOS'){
              //     yo.items = yo.items.filter(
              //         invoice => invoice.cultivo === yo.responsable[0].cultivo
              //     )

              //   }else if(yo.responsable[0].cultivo === 'TODOS'){
              //     yo.items = yo.items.filter(
              //         invoice => invoice.empresa === yo.responsable[0].empresa
              //     )
              //   }else{
              //     console.log("ELSE")
              //     yo.items = yo.items.filter(
              //         invoice => invoice.cultivo === yo.responsable[0].cultivo && invoice.empresa === yo.responsable[0].empresa
              //     )
              //   }

              //   yo.estados = [
              //     {value: '1', text: "Dar visto bueno"},
              //     {value: '4', text: "Eliminar"}
              //   ]
              // }else if(yo.responsable[0].rol === 'JEFE CORPORATIVO'){
              //   yo.estados = [
              //     {value: '5', text: "Dar Conformidad"}
              //   ]

              //   yo.items = yo.items.filter(
              //       invoice => invoice.empresa === yo.responsable[0].empresa && invoice.estado !== '0'
              //   )

              // }else{
              //   yo.estados = [
              //     {value: '1', text: "Dar visto bueno"},
              //     {value: '2', text: "Aprobar"},
              //     {value: '3', text: "Desaprobar"},
              //     {value: '4', text: "Eliminar"},
              //     {value: '5', text: "Dar Conformidad"}
              //   ]
              // }

            }

          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loading = false
          })
    },

    traerDataEmpresa(){
      const yo = this
      yo.loadingDE = true

      const data = JSON.stringify
      (
        {
          'version_elegida': 'A-V01.1 ENE',
          'subversion_elegida': '001'
        }
      )

      const config = {
        method: 'post',
        url: '/pagricolas/lotes/obtenerSoloLotesValvulasDetallado/',
        // url: '/lotes/obtenerLotesValvulasDetallado/',
        data: data
      }

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              let data_resumida_agrupada = []
              data_resumida_agrupada = yo.armarResumen(response.data['data'], response.data['cod_unicos']) //La data que ya esta agrupada por Activos, Pendientes y Agrupados

              yo.dataEmpresa = data_resumida_agrupada
              // console.log(yo.dataEmpresa)
              // yo.dataEmpresa = response.data['data'] //Por el momento le estoy asignando de frente la detallada
              // yo.dataCompleta = response.data['data']

              for (let value of yo.dataEmpresa){
                yo.empresas.push(value.sociedad)
              }

              yo.empresas = [...new Set(yo.empresas)].sort()

            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){

          })

    },

    //Esta funcion toma todos los registros detallados y los agrupa en Activos, Pendientes y Agrupados
    armarResumen(total_lotes_valvulas,cod_homo_unicos){

      let resumen_lotes_valvulas = [] //Almacenara los datos que se mostraran primero
      let turnos_vacios_sinlotesval = []

      for(let c of cod_homo_unicos){
        let resultadosFiltrados = []
        //Del total filtro solo los que cumplen con el cod_homologado
        resultadosFiltrados = total_lotes_valvulas.filter(function(item) {
          return item.cod_homologado === c;
        });

        if(resultadosFiltrados.length > 0){
          // Recorro lo filtrado para volverle a pasar un segundo filtros entre Activos, Pendientes y Agrupados
          let lista_activos = []
          let lista_pendientes = []
          let lista_agrupados = []
          let lista_final = [] //Almacen el resumen por grupo segun el cod_homologado

          for(let x of resultadosFiltrados){
            //Activos
            if(x['estado_uno'] == '0'){ // 0  es Activo
              lista_activos.push(x)
            }
            //Pendientes
            if(x['estado_dos'] == '0'){
              lista_pendientes.push(x)
            }
            //Agrupados
            if(x['estado_uno'] == '1'){
              lista_agrupados.push(x)
            }

            if(x['lote'] == null || x['lote'] == ''){
              turnos_vacios_sinlotesval.push(x)
            }
          }


          if(lista_activos.length > 0){
            // Ahora trabajo la lista_final_activos
            let lista_final_activos = []
            let acumulador_activos = {
              estado_uno: 0,
              lote: [],
              valvula: [],
              area_subtotal: 0,
              area_real: 0,
              diferencia: 0,
              estado_dos: 0,
              cod_homologado: '',
              estado_resumen:'',
              area_total: ''
            }

            // ----Recorrer lista_activos y acumular valores
            lista_activos.forEach(function(item) {
              acumulador_activos.lote += item.lote + ",";
              acumulador_activos.valvula += item.valvula + ",";
              acumulador_activos.area_subtotal += item.area_subtotal;
              acumulador_activos.area_real += item.area_real;
              acumulador_activos.diferencia += item.diferencia;
              acumulador_activos.cod_homologado = item.cod_homologado;
              acumulador_activos.cod_homologado_turno = item.cod_homologado_turno;
              acumulador_activos.estado_uno_texto = item.estado_uno_texto;
              acumulador_activos.estado_dos_texto = item.estado_dos_texto;
              acumulador_activos.sociedad = item.sociedad;
              acumulador_activos.cultivo = item.cultivo;
              acumulador_activos.fundo = item.fundo;
              acumulador_activos.etapa = item.etapa;
              acumulador_activos.campo = item.campo;
              acumulador_activos.turno = item.turno;
              acumulador_activos.variedad = item.variedad;
              acumulador_activos.estado_resumen = item.estado_uno_texto;
              // acumulador_activos.area_total = item.area_ha;
              acumulador_activos.area_ha = item.area_ha;
              // acumulador_activos.id = item.turno_id;
              acumulador_activos.id_turno = item.id_turno;
            })

            // ----Eliminar la última coma de las cadenas de lote y valvula
            acumulador_activos.lote = acumulador_activos.lote.slice(0, -1);
            acumulador_activos.valvula = acumulador_activos.valvula.slice(0, -1);

            // ----Agregar el acumulador a lista_final_activos
            lista_final_activos.push(acumulador_activos);
            resumen_lotes_valvulas.push(acumulador_activos)
          }

          if(lista_pendientes.length > 0){
            // Ahora trabajo la lista_final_pendientes
            let lista_final_pendientes = []
            let acumulador_pendientes = {
              estado_uno: 0,
              lote: [],
              valvula: [],
              area_subtotal: 0,
              area_real: 0,
              diferencia: 0,
              estado_dos: 0,
              cod_homologado: '',
              estado_resumen:'',
              area_total:'',
            }

            lista_pendientes.forEach(function(item) {
              acumulador_pendientes.lote += item.lote + ",";
              acumulador_pendientes.valvula += item.valvula + ",";
              acumulador_pendientes.area_subtotal += item.area_subtotal;
              // acumulador_pendientes.area_real += item.area_real;
              acumulador_pendientes.area_real += item.diferencia; //Cuando solo son pendientes el area_real debe ser la sumatoria de la diferencia
              acumulador_pendientes.diferencia += item.diferencia;
              acumulador_pendientes.cod_homologado = item.cod_homologado;
              acumulador_pendientes.cod_homologado_turno = item.cod_homologado_turno;
              acumulador_pendientes.estado_uno_texto = item.estado_uno_texto;
              acumulador_pendientes.estado_dos_texto = item.estado_dos_texto;
              acumulador_pendientes.sociedad = item.sociedad;
              acumulador_pendientes.cultivo = item.cultivo;
              acumulador_pendientes.fundo = item.fundo;
              acumulador_pendientes.etapa = item.etapa;
              acumulador_pendientes.campo = item.campo;
              acumulador_pendientes.turno = item.turno;
              acumulador_pendientes.variedad = item.variedad;
              acumulador_pendientes.estado_resumen = item.estado_dos_texto;
              // acumulador_pendientes.area_total = item.area_ha;
              acumulador_pendientes.area_ha = item.area_ha;
              // acumulador_pendientes.id = item.turno_id;
              acumulador_pendientes.id_turno = item.id_turno;
            })

            // ----Eliminar la última coma de las cadenas de lote y valvula
            acumulador_pendientes.lote = acumulador_pendientes.lote.slice(0, -1);
            acumulador_pendientes.valvula = acumulador_pendientes.valvula.slice(0, -1);

            // ----Agregar el acumulador a lista_final_activos
            lista_final_pendientes.push(acumulador_pendientes);

            for(let y of lista_final_pendientes){
              if(y['estado_dos'] == '0'){
                y['estado_uno_texto'] = 'PENDIENTE'
              }
            }
            resumen_lotes_valvulas.push(acumulador_pendientes)
          }

          for(let z of lista_agrupados){
            z['estado_resumen'] = 'AGRUPADO'
            z['area_total'] = z['area_ha']
            resumen_lotes_valvulas.push(z)
          }
        }

      }

      return resumen_lotes_valvulas;

    },

    traerDataLotesValvulas(){
      const yo = this
      yo.loadingDE = true

      const config = {
        method: 'get',
        url: '/pagricolas/lotes/'
      }

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.dataLotesValvulas = response.data
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loadingDE = false
          })

    },

    asignarCultivos(){
      const yo = this
      yo.cultivos = []
      yo.cultivo = null
      yo.fundos = []
      yo.fundo = null
      yo.etapas = []
      yo.etapa = null
      yo.campos = []
      yo.campo = null
      yo.turnos = []
      yo.codigos_h = []
      yo.codigo_h = null
      yo.turno = null
      yo.variedad = null
      yo.lote = null
      yo.valvula = null
      yo.area = null

      for(let value of yo.dataEmpresa){
        if(value.sociedad === yo.empresa){
          yo.cultivos.push(value.cultivo)
        }
      }

      yo.cultivos = yo.cultivos.filter(item => item !== null);
      yo.cultivos = [... new Set(yo.cultivos)]

    },

    asignarFundos(){
      const yo = this
      yo.fundos = []
      yo.fundo = null
      yo.etapas = []
      yo.etapa = null
      yo.campos = []
      yo.campo = null
      yo.turnos = []
      yo.turno = null
      yo.codigos_h = []
      yo.codigo_h = null
      yo.variedad = null
      yo.lote = null
      yo.valvula = null
      yo.area = null

      for(let value of yo.dataEmpresa){
        if(value.sociedad === yo.empresa && value.cultivo === yo.cultivo){
          yo.fundos.push(value.fundo)
        }
      }

      yo.fundos = [... new Set(yo.fundos)]

    },

    asignarEtapas(){
      const yo = this

      yo.etapas = []
      yo.etapa = null
      yo.campos = []
      yo.campo = null
      yo.turnos = []
      yo.turno = null
      yo.codigos_h = []
      yo.codigo_h = null
      yo.variedad = null
      yo.lote = null
      yo.valvula = null
      yo.area = null

      for(let value of yo.dataEmpresa){
        if(value.sociedad === yo.empresa && value.cultivo === yo.cultivo && value.fundo === yo.fundo){
          yo.etapas.push(value.etapa)
        }
      }

      yo.etapas = [... new Set(yo.etapas)]

    },

    asignarCampos(){
      const yo = this

      yo.campos = []
      yo.campo = null
      yo.turnos = []
      yo.turno = null
      yo.codigos_h = []
      yo.codigo_h = null
      yo.variedad = null
      yo.lote = null
      yo.valvula = null
      yo.area = null

      for(let value of yo.dataEmpresa){
        if(value.sociedad === yo.empresa && value.cultivo === yo.cultivo && value.fundo === yo.fundo && value.etapa === yo.etapa){
          yo.campos.push(value.campo)
        }
      }

      yo.campos = [... new Set(yo.campos)]

    },

    asignarTurnos(){
      const yo = this

      yo.turnos = []
      yo.turno = null
      yo.codigos_h = []
      yo.codigo_h = null
      yo.variedad = null
      yo.lote = null
      yo.valvula = null
      yo.area = null

      for(let value of yo.dataEmpresa){
        if(value.sociedad === yo.empresa && value.cultivo === yo.cultivo && value.fundo === yo.fundo && value.etapa === yo.etapa && value.campo === yo.campo){
          yo.turnos.push(value.turno)
        }
      }

      yo.turnos = [... new Set(yo.turnos)]

    },

    filtrarPorEstadoUno(){
      const yo = this
      let codhomo_filtrados = []
      let estado_uno_seleccionado
      if(yo.estado_lote == 0){
        estado_uno_seleccionado = 'ACTIVO'
      }else if(yo.estado_lote == 1){
        estado_uno_seleccionado = 'AGRUPADO'
      }else if(yo.estado_lote == 2){
        estado_uno_seleccionado = 'PENDIENTE'
      }

      for(let x of yo.codigos_h_resp){
        if(x['data']['estado_uno_texto'] === estado_uno_seleccionado){
          codhomo_filtrados.push(x)
        }
      }
      console.log(codhomo_filtrados)
      yo.codigos_h = []
      yo.codigos_h = codhomo_filtrados

    },

    asignarCodigos(){
      const yo = this

      yo.codigos_h = []
      yo.codigo_h = null
      yo.variedad = null
      yo.lote = null
      yo.valvula = null
      yo.area = null

      let s_cod_homologado = ''
      let cod_homo_activos = []
      for(let value of yo.dataEmpresa){
        if(value.sociedad === yo.empresa && value.cultivo === yo.cultivo && value.fundo === yo.fundo && value.etapa === yo.etapa && value.campo === yo.campo && value.turno === yo.turno){ //0:Activo, 1:Agrupado
          s_cod_homologado = value.cod_homologado;
          yo.codigos_h.push({
            "codigo_h": value.cod_homologado,
            "data": {
              "codigo_h": value.cod_homologado_new,
              "cod_homologado": value.cod_homologado,
              "variedad": value.variedad,
              "area": value.area_ha,
              "lote": value.lote,
              "valvula": value.valvula,
              "estado_uno": value.estado_uno,
              "estado_uno_texto": value.estado_uno_texto,
            }
          })

        }
      }
      yo.codigos_h_resp = yo.codigos_h

    },

    seleccionarCodigoN(){
      const yo = this
      yo.variedad = null
      yo.lote = null
      yo.valvula = null
      yo.area = null

      yo.variedad = yo.codigo_h.variedad
      yo.area = yo.codigo_h.area
      yo.lote = yo.codigo_h.lote
      yo.valvula = yo.codigo_h.valvula
    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    //NUEVO REGISTRO
    handleSubmit() {

      const yo = this
      console.log(yo.codigo_h.codigo_h)
      this.$refs.formularioRiego.validate().then(success => {
        if (success && !yo.mostrarAlert && !yo.mostrarAlert2)  {
          yo.loading2 = true

          let estado_lote = yo.estado_lote

          if(estado_lote == '0'){
            estado_lote = 'ACTIVO'
          }else if(estado_lote == '1'){
            estado_lote = 'AGRUPADO'
          }else{
            estado_lote = 'PENDIENTE'
          }

          const data = JSON.stringify({
            'semana': yo.semanaActual ? yo.semana : yo.semana_sig,
            'estado_lote': estado_lote,
            'fecha': yo.fecha,
            'anio' : yo.fecha.substring(0,4),
            'fundo': yo.fundo,
            'cultivo': yo.cultivo,
            'etapa': yo.etapa,
            'empresa': yo.empresa,
            'campo': yo.campo,
            'turno': yo.turno,
            // 'cod_homologado':yo.codigo_h.codigo_h,
            'cod_homologado':yo.codigo_h.cod_homologado,

            'variedad': yo.variedad,
            'lote': yo.lote,
            'valvula': yo.valvula,
            'area': yo.area,

            'eto': yo.eto,
            'kc': yo.kc,
            'lr_dia':yo.lr_dia,
            'descarga_caudal_hora':yo.descarga_caudal_hora,

            'volumen':yo.volumen,
            'ciclos_riego':yo.ciclos_riego,
            'riego_total':yo.riego_total,
            'horas':yo.horas,
            'riego_cortina':yo.riego_cortina,
            'con_sin_fertilizante':yo.con_sin_fertilizante,

            'ciclo_1':yo.ciclo_1,
            'estanque_uno_1':yo.estanque_uno_1,
            'estanque_dos_1':yo.estanque_dos_1,
            'estanque_tres_1':yo.estanque_tres_1,
            'hora_inicio_1':yo.hora_inicio_1,
            'horas_inicio_seg_ciclo':yo.horas_inicio_seg_ciclo,

            'ciclo_2':yo.ciclo_2,
            'estanque_uno_2':yo.estanque_uno_2,
            'estanque_dos_2':yo.estanque_dos_2,
            'estanque_tres_2':yo.estanque_tres_2,
            'hora_inicio_2':yo.hora_inicio_2,
            'horas_inicio_ter_ciclo':yo.horas_inicio_ter_ciclo,

            'ciclo_3':yo.ciclo_3,
            'estanque_uno_3':yo.estanque_uno_3,
            'estanque_dos_3':yo.estanque_dos_3,
            'estanque_tres_3':yo.estanque_tres_3,
            'hora_inicio_3':yo.hora_inicio_3,
            'horas_inicio_cuarto_ciclo':yo.horas_inicio_cuarto_ciclo,

            'ciclo_4':yo.ciclo_4,
            'estanque_uno_4':yo.estanque_uno_4,
            'estanque_dos_4':yo.estanque_dos_4,
            'estanque_tres_4':yo.estanque_tres_4,
            'hora_inicio_4':yo.hora_inicio_4,
            'horas_inicio_quinto_ciclo':yo.horas_inicio_quinto_ciclo,

            'ciclo_5':yo.ciclo_5,
            'estanque_uno_5':yo.estanque_uno_5,
            'estanque_dos_5':yo.estanque_dos_5,
            'estanque_tres_5':yo.estanque_tres_5,
            'hora_inicio_5':yo.hora_inicio_5,
            'horas_inicio_sexto_ciclo':yo.horas_inicio_sexto_ciclo,

            'ciclo_6':yo.ciclo_6,
            'estanque_uno_6':yo.estanque_uno_6,
            'estanque_dos_6':yo.estanque_dos_6,
            'estanque_tres_6':yo.estanque_tres_6,
            'hora_inicio_6':yo.hora_inicio_6,
            'horas_inicio_septimo_ciclo':yo.horas_inicio_septimo_ciclo,

            'ciclo_7':yo.ciclo_7,
            'estanque_uno_7':yo.estanque_uno_7,
            'estanque_dos_7':yo.estanque_dos_7,
            'estanque_tres_7':yo.estanque_tres_7,
            'hora_inicio_7':yo.hora_inicio_7,

            'comentarios':yo.comentarios,
            'estado': '0',
            'con_usuario': yo.id_user,
            'parametros_usuario': JSON.stringify(yo.parametros_usuario)
          })

          const config = {
            method: 'post',
            url: 'pagricolas/riego/crear/',
            headers: {
              'Content-Type': 'application/json'
            },
            data: data
          }

          axiosIns(config)
              .then(function (response) {
                // console.log(response)
                if (response.status === 200 ){
                  if(response.data['errores']){
                    let error=response.data['errores'][0]['error']
                    yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', error , 'warning', 6000)
                  }else{
                    yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se realizó de manera correcta", 'success', 5000)
                  }
                }

                if (response.status=== 202 ){
                  yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "El registro no se realizó porque los anteriores ya pasaron a estado Revisado", 'warning', 6000)
                }

                // if (response.status=== 202 ){
                //   yo.mostrarNotificacion('Error en el registro', 'BellIcon', "La operación no se completó", 'danger', 6000)
                // }

              })
              .catch(function (error) {
                console.log(error);
                yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger', 5000)
              })
              .finally(function (){
                yo.traerRiegos()
                yo.$nextTick(() => {
                  yo.$refs['my-modal'].toggle('#toggle-btn')
                })
                yo.loading2 = false
              })

        }
      })
    },

    editarRegistro(){
      const yo = this

      this.$refs.formularioEditarRiego.validate().then(success => {
        if (success){
          yo.loadingEditar = true

          const data = JSON.stringify({
            'semana': yo.semanaActual ? yo.semana : yo.semana_sig,
            'fundo': yo.fundo,
            'cultivo': yo.cultivo,
            'etapa': yo.etapa,
            'empresa': yo.empresa,
            'campo': yo.campo,
            'turno': yo.turno,
            'cod_homologado':yo.codigo_h.codigo_h,

            'variedad': yo.variedad,
            'lote': yo.lote,
            'valvula': yo.valvula,
            'area': yo.area,

            'eto': yo.eto,
            'kc': yo.kc,
            'lr_dia':yo.lr_dia,
            'descarga_caudal_hora':yo.descarga_caudal_hora,

            'volumen':yo.volumen,
            'ciclos_riego':yo.ciclos_riego,
            'riego_total':yo.riego_total,
            'horas':yo.horas,
            'riego_cortina':yo.riego_cortina,
            'con_sin_fertilizante':yo.con_sin_fertilizante,

            'ciclo_1':yo.ciclo_1,
            'estanque_uno_1':yo.estanque_uno_1,
            'estanque_dos_1':yo.estanque_dos_1,
            'estanque_tres_1':yo.estanque_tres_1,
            'hora_inicio_1':yo.hora_inicio_1,
            'horas_inicio_seg_ciclo':yo.horas_inicio_seg_ciclo,

            'ciclo_2':yo.ciclo_2,
            'estanque_uno_2':yo.estanque_uno_2,
            'estanque_dos_2':yo.estanque_dos_2,
            'estanque_tres_2':yo.estanque_tres_2,
            'hora_inicio_2':yo.hora_inicio_2,
            'horas_inicio_ter_ciclo':yo.horas_inicio_ter_ciclo,

            'ciclo_3':yo.ciclo_3,
            'estanque_uno_3':yo.estanque_uno_3,
            'estanque_dos_3':yo.estanque_dos_3,
            'estanque_tres_3':yo.estanque_tres_3,
            'hora_inicio_3':yo.hora_inicio_3,
            'horas_inicio_cuarto_ciclo':yo.horas_inicio_cuarto_ciclo,

            'ciclo_4':yo.ciclo_4,
            'estanque_uno_4':yo.estanque_uno_4,
            'estanque_dos_4':yo.estanque_dos_4,
            'estanque_tres_4':yo.estanque_tres_4,
            'hora_inicio_4':yo.hora_inicio_4,
            'horas_inicio_quinto_ciclo':yo.horas_inicio_quinto_ciclo,

            'ciclo_5':yo.ciclo_5,
            'estanque_uno_5':yo.estanque_uno_5,
            'estanque_dos_5':yo.estanque_dos_5,
            'estanque_tres_5':yo.estanque_tres_5,
            'hora_inicio_5':yo.hora_inicio_5,
            'horas_inicio_sexto_ciclo':yo.horas_inicio_sexto_ciclo,

            'ciclo_6':yo.ciclo_6,
            'estanque_uno_6':yo.estanque_uno_6,
            'estanque_dos_6':yo.estanque_dos_6,
            'estanque_tres_6':yo.estanque_tres_6,
            'hora_inicio_6':yo.hora_inicio_6,
            'horas_inicio_septimo_ciclo':yo.horas_inicio_septimo_ciclo,

            'ciclo_7':yo.ciclo_7,
            'estanque_uno_7':yo.estanque_uno_7,
            'estanque_dos_7':yo.estanque_dos_7,
            'estanque_tres_7':yo.estanque_tres_7,
            'hora_inicio_7':yo.hora_inicio_7,


            'comentarios':yo.comentarios,
            'estado': '0',
            'con_usuario': yo.id_user,

          })

          const config = {
            method: 'put',
            url: 'pagricolas/riego/editar/'+yo.id_editar,
            headers: {
              'Content-Type': 'application/json'
            },
            data: data
          }


          axiosIns(config)
              .then(function (response) {
                if (response.status === 200){
                  yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se editó de manera correcta", 'success', 5000)
                }
              })
              .catch(function (error) {
                console.log(error);
                yo.mostrarNotificacion('Error en la edición', 'BellIcon', 'Error: \n '+error.toString(), 'danger', 5000)
              })
              .finally(function (){
                yo.mostrarSemAct=false
                yo.mostrarSemSgte=false
                yo.traerRiegos()

                yo.$nextTick(() => {
                  yo.$refs['modal-editar'].toggle('#toggle-btn')
                })
                yo.loadingEditar = false
              })

        }
      })
    },

    resetModal() {

      this.name = ''
      this.nameState = null

      this.empresa= null
      this.cultivo= null
      this.fundo= null
      this.etapa= null
      this.campo= null
      this.turno= null
      this.codigo_h=null

      this.variedad= null
      this.lote= null
      this.valvula= null
      this.area= null

      this.eto=null
      this.kc=null
      this.lr_dia=null
      this.descarga_caudal_hora=null

      this.volumen=null
      this.ciclos_riego=null
      this.riego_total=null
      this.horas=null
      this.riego_cortina=null
      this.con_sin_fertilizante=null

      this.ciclo_1=null
      this.estanque_uno_1=null
      this.estanque_dos_1=null
      this.estanque_tres_1=null
      this.hora_inicio_1=null
      this.horas_inicio_seg_ciclo=null

      this.ciclo_2=null
      this.estanque_uno_2=null
      this.estanque_dos_2=null
      this.estanque_tres_2=null
      this.hora_inicio_2=null
      this.horas_inicio_ter_ciclo=null

      this.ciclo_3=null
      this.estanque_uno_3=null
      this.estanque_dos_3=null
      this.estanque_tres_3=null
      this.hora_inicio_3=null
      this.horas_inicio_cuarto_ciclo=null

      this.ciclo_4=null
      this.estanque_uno_4=null
      this.estanque_dos_4=null
      this.estanque_tres_4=null
      this.hora_inicio_4=null
      this.horas_inicio_quinto_ciclo=null

      this.ciclo_5=null
      this.estanque_uno_5=null
      this.estanque_dos_5=null
      this.estanque_tres_5=null
      this.hora_inicio_5=null
      this.horas_inicio_sexto_ciclo=null

      this.ciclo_6=null
      this.estanque_uno_6=null
      this.estanque_dos_6=null
      this.estanque_tres_6=null
      this.hora_inicio_6=null
      this.horas_inicio_septimo_ciclo=null

      this.ciclo_7=null
      this.estanque_uno_7=null
      this.estanque_dos_7=null
      this.estanque_tres_7=null
      this.hora_inicio_7=null

      this.comentarios=null

      this.dataInicial()

      this.semana = this.semanaActual ? this.semana : this.semana_sig
    },

    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },

    validarRegistroEditar(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.editarRegistro()
    },

    importarOk(bvModalEvtImp) {
      // Prevent modal from closing
      bvModalEvtImp.preventDefault()
      // Trigger submit handler
      this.enviarFile()
    },

    calcularLrDia(){

      this.lr_dia=(this.eto*this.kc*10).toFixed(2)
      this.volumen=Math.round(this.lr_dia*this.area)
      this.riego_total=(this.volumen/this.area).toFixed(2)
      this.horas=(this.lr_dia/this.descarga_caudal_hora).toFixed(1)
      this.riego_cortina=Math.round(this.horas*2)

      if(this.ciclos_riego==1 || this.ciclos_riego>7){

        this.ciclo_1=Math.round(this.area*(this.lr_dia/this.ciclos_riego))

        this.ciclo_2=0
        this.estanque_uno_2=0
        this.estanque_dos_2=0
        this.estanque_tres_2=0
        this.hora_inicio_2=null
        this.horas_inicio_seg_ciclo=0

        this.ciclo_3=0
        this.estanque_uno_3=0
        this.estanque_dos_3=0
        this.estanque_tres_3=0
        this.hora_inicio_3=null
        this.horas_inicio_ter_ciclo=0

        this.ciclo_4=0
        this.estanque_uno_4=0
        this.estanque_dos_4=0
        this.estanque_tres_4=0
        this.hora_inicio_4=null
        this.horas_inicio_cuarto_ciclo=0

        this.ciclo_5=0
        this.estanque_uno_5=0
        this.estanque_dos_5=0
        this.estanque_tres_5=0
        this.hora_inicio_5=null
        this.horas_inicio_quinto_ciclo=0

        this.ciclo_6=0
        this.estanque_uno_6=0
        this.estanque_dos_6=0
        this.estanque_tres_6=0
        this.hora_inicio_6=null
        this.horas_inicio_sexto_ciclo=0

        this.ciclo_7=0
        this.estanque_uno_7=0
        this.estanque_dos_7=0
        this.estanque_tres_7=0
        this.hora_inicio_7=null
        this.horas_inicio_septimo_ciclo=0

      }else if (this.ciclos_riego==2) {
        this.ciclo_1=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_2=Math.round(this.area*(this.lr_dia/this.ciclos_riego))

        this.ciclo_3=0
        this.estanque_uno_3=0
        this.estanque_dos_3=0
        this.estanque_tres_3=0
        this.hora_inicio_3=null
        this.horas_inicio_ter_ciclo=0

        this.ciclo_4=0
        this.estanque_uno_4=0
        this.estanque_dos_4=0
        this.estanque_tres_4=0
        this.hora_inicio_4=null
        this.horas_inicio_cuarto_ciclo=0

        this.ciclo_5=0
        this.estanque_uno_5=0
        this.estanque_dos_5=0
        this.estanque_tres_5=0
        this.hora_inicio_5=null
        this.horas_inicio_quinto_ciclo=0

        this.ciclo_6=0
        this.estanque_uno_6=0
        this.estanque_dos_6=0
        this.estanque_tres_6=0
        this.hora_inicio_6=null
        this.horas_inicio_sexto_ciclo=0

        this.ciclo_7=0
        this.estanque_uno_7=0
        this.estanque_dos_7=0
        this.estanque_tres_7=0
        this.hora_inicio_7=null
        this.horas_inicio_septimo_ciclo=0

      }else if (this.ciclos_riego==3){
        this.ciclo_1=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_2=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_3=Math.round(this.area*(this.lr_dia/this.ciclos_riego))

        this.ciclo_4=0
        this.estanque_uno_4=0
        this.estanque_dos_4=0
        this.estanque_tres_4=0
        this.hora_inicio_4=null
        this.horas_inicio_cuarto_ciclo=0

        this.ciclo_5=0
        this.estanque_uno_5=0
        this.estanque_dos_5=0
        this.estanque_tres_5=0
        this.hora_inicio_5=null
        this.horas_inicio_quinto_ciclo=0

        this.ciclo_6=0
        this.estanque_uno_6=0
        this.estanque_dos_6=0
        this.estanque_tres_6=0
        this.hora_inicio_6=null
        this.horas_inicio_sexto_ciclo=0

        this.ciclo_7=0
        this.estanque_uno_7=0
        this.estanque_dos_7=0
        this.estanque_tres_7=0
        this.hora_inicio_7=null
        this.horas_inicio_septimo_ciclo=0

      }else if (this.ciclos_riego==4){
        this.ciclo_1=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_2=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_3=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_4=Math.round(this.area*(this.lr_dia/this.ciclos_riego))

        this.ciclo_5=0
        this.estanque_uno_5=0
        this.estanque_dos_5=0
        this.estanque_tres_5=0
        this.hora_inicio_5=null
        this.horas_inicio_quinto_ciclo=0

        this.ciclo_6=0
        this.estanque_uno_6=0
        this.estanque_dos_6=0
        this.estanque_tres_6=0
        this.hora_inicio_6=null
        this.horas_inicio_sexto_ciclo=0

        this.ciclo_7=0
        this.estanque_uno_7=0
        this.estanque_dos_7=0
        this.estanque_tres_7=0
        this.hora_inicio_7=null
        this.horas_inicio_septimo_ciclo=0

      }else if (this.ciclos_riego==5){
        this.ciclo_1=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_2=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_3=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_4=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_5=Math.round(this.area*(this.lr_dia/this.ciclos_riego))

        this.ciclo_6=0
        this.estanque_uno_6=0
        this.estanque_dos_6=0
        this.estanque_tres_6=0
        this.hora_inicio_6=null
        this.horas_inicio_sexto_ciclo=0

        this.ciclo_7=0
        this.estanque_uno_7=0
        this.estanque_dos_7=0
        this.estanque_tres_7=0
        this.hora_inicio_7=null
        this.horas_inicio_septimo_ciclo=0

      }else if (this.ciclos_riego==6){
        this.ciclo_1=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_2=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_3=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_4=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_5=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_6=Math.round(this.area*(this.lr_dia/this.ciclos_riego))

        this.ciclo_7=0
        this.estanque_uno_7=0
        this.estanque_dos_7=0
        this.estanque_tres_7=0
        this.hora_inicio_7=null
        this.horas_inicio_septimo_ciclo=0

      }else if (this.ciclos_riego==7){
        this.ciclo_1=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_2=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_3=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_4=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_5=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_6=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
        this.ciclo_7=Math.round(this.area*(this.lr_dia/this.ciclos_riego))
      }




    },

    calcularMaxDia(){
      const kg = this.kg_ha_dia
      const are = this.area
      this.total_max_dia = (kg * are).toLocaleString('es-PE', {minimumFractionDigits: 2, maximumFractionDigits: 5})
    },

    mostrarNotificacion(titulo, icono, texto, variante, tiempo){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: tiempo,
            position: 'top-center',
          })
    },

    comporbarExcedente(){

      const suma = parseFloat(this.lunes) + parseFloat(this.martes) + parseFloat(this.miercoles) + parseFloat(this.jueves) + parseFloat(this.viernes) + parseFloat(this.sabado) + parseFloat(this.domingo)
      const resultado = (suma / parseInt(this.dias)).toLocaleString('es-PE', {maximumFractionDigits: 5})

      this.mostrarAlert = resultado !== this.total_max_dia;

      let c = 0

      c = parseFloat(this.lunes) !== 0 ? c+1 : c
      c = parseFloat(this.martes) !== 0 ? c+1 : c
      c = parseFloat(this.miercoles) !== 0 ? c+1 : c
      c = parseFloat(this.jueves) !== 0 ? c+1 : c
      c = parseFloat(this.viernes) !== 0 ? c+1 : c
      c = parseFloat(this.sabado) !== 0 ? c+1 : c
      c = parseFloat(this.domingo) !== 0 ? c+1 : c

      this.mostrarAlert2 = c !== parseInt(this.dias);

    },

    numeroDeSemana(fecha){
      const DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24, DIAS_QUE_TIENE_UNA_SEMANA = 7, JUEVES = 4;

      // fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()+7));
      fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()));

      let diaDeLaSemana = fecha.getUTCDay(); // Domingo es 0, sábado es 6
      if (diaDeLaSemana === 0) {
        diaDeLaSemana = 7;
      }

      fecha.setUTCDate(fecha.getUTCDate() - diaDeLaSemana + JUEVES);

      const inicioDelAnio = new Date(Date.UTC(fecha.getUTCFullYear(), 0, 1));

      const diferenciaDeFechasEnMilisegundos = fecha - inicioDelAnio;

      return {
        n_semana: Math.ceil(((diferenciaDeFechasEnMilisegundos / DIA_EN_MILISEGUNDOS) + 1) / DIAS_QUE_TIENE_UNA_SEMANA),
        inicio: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate() - fecha.getDay() + 1),
        fin: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate() + 7 - fecha.getDay()),
      }

    },

    asignarInicioFinSemana(){
      this.inicioSemana = ''
      this.finSemana = ''

      if (this.semana >= 1 && this.semana <= 52){
        const hoy = new Date()
        const fech = new Date(Date.UTC(hoy.getFullYear(), 0, 1));

        fech.setDate(fech.getDate() + (this.semana*7));

        const inicio = new Date(fech.getFullYear(), fech.getMonth(), fech.getDate() - fech.getDay() + 1)
        const fin = new Date(fech.getFullYear(), fech.getMonth(), fech.getDate() + 7 - fech.getDay())

        this.inicioSemana = inicio.toLocaleString('pe-PE', {
          month: 'long',
          day: '2-digit',
          year: 'numeric',
          localeMatcher: 'best fit',
          timeZone: 'America/Lima'
        })
        this.finSemana = fin.toLocaleString('pe-PE', {
          month: 'long',
          day: '2-digit',
          year: 'numeric',
          localeMatcher: 'best fit',
          timeZone: 'America/Lima'
        })
      }
    },

    enviarFile(){
      const yo = this
      this.$refs.formularioImportar.validate().then(success => {
        if (success) {
          this.loadingIMP = true
          const data = new FormData();
          data.append('file', yo.archivo_excel)
          data.append('con_usuario', yo.id_user)
          data.append('semana', yo.semanaEnviar)
          data.append('parametros_usuario', JSON.stringify(yo.parametros_usuario))

          const config = {
            method: 'post',
            url: '/pagricolas/riego/importar/filter/',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: data
          }

          axiosIns(config)
              .then(function (response) {
                console.log(response)
                if(response.status === 200){
                  yo.traerRiegos()

                  if (response.data['errores'].length > 0){
                    yo.respuestaErrores=response.data['errores']
                    yo.mostrarErrores=true
                  }else{
                    if(response.data['total']=='-1'){
                      yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "El registro no se realizó porque los anteriores ya pasaron a estado Revisado", 'warning', 6000)
                    }
                    else{
                      yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "La importación se realizó correctamente", 'success', 5000)
                    }

                  }


                }
              })
              .catch(function (error) {
                console.log(error);

                yo.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Error en el registro',
                    icon: 'XIcon',
                    text: 'Hubo un error en el registro, intentelo nuevamente en unos minutos.',
                    variant: 'danger',
                  },
                })
              })
              .finally(function () {
                yo.archivo_excel = null
                yo.cultivoIMP = null
                yo.loadingIMP = false
                yo.$nextTick(() => {
                  yo.$refs['modal-importar'].toggle('#toggle-btn')
                })

                // yo.estadoModalRespuesta = true
              })
        }
      })
    },

    autorizar(data){
      const yo=this;
      this.estado_aprobar = null
      let conta=0;

      if(data['estado'] === '5'){
        if(yo.responsable[0].rol === 'JEFE DE RIEGO' || yo.responsable[0].rol === 'USUARIO'){
          this.mostrarNotificacion('Advertencia', 'BellIcon', "No tienes permisos para modificar el estado de este registro.", 'warning', 6000)
          conta = conta + 1
        }
      }else if(data['estado'] === '1' || data['estado'] === '2' || data['estado'] === '3'){
        if(yo.responsable[0].rol === 'USUARIO'){
          this.mostrarNotificacion('Advertencia', 'BellIcon', "No tienes permisos para modificar el estado de este registro.", 'warning', 6000)
          conta = conta + 1
        }
      }

      if (conta<1){
        this.modalEditarEstadoShow = true
        this.dataAutorizar = data.semana + "*" + data.cultivo + "*" + data.empresa + "*" + data.fundo + "*" + data.version
      }

    },

    verDetalle(datos){
      const yo = this
      yo.items_sem_act = yo.spd.filter(invoice => invoice.semana+invoice.cultivo+invoice.empresa+invoice.version === datos.semana+datos.cultivo+datos.empresa+datos.version)

      yo.mostrarSemAct = true
    },

    verDetalleSemSgte(datos){
      const yo = this
      yo.items_sem_sgte = yo.spd.filter(invoice => invoice.semana+invoice.cultivo+invoice.empresa+invoice.version === datos.semana+datos.cultivo+datos.empresa+datos.version)

      yo.mostrarSemSgte = true
    },

    asignarMaxDiaSemana(){
      const yo = this
      yo.lunes = '0.0'
      yo.martes = '0.0'
      yo.miercoles = '0.0'
      yo.jueves = '0.0'
      yo.viernes = '0.0'
      yo.sabado = '0.0'
      yo.domingo = '0.0'

      if (yo.dias >= 1 && yo.dias <= 7){
        for (let i = 1; i<=7; i++){
          if (i<=yo.dias && i===1){
            yo.lunes = yo.total_max_dia
          }

          if (i<=yo.dias && i===2){
            yo.martes = yo.total_max_dia
          }

          if (i<=yo.dias && i===3){
            yo.miercoles = yo.total_max_dia
          }

          if (i<=yo.dias && i===4){
            yo.jueves = yo.total_max_dia
          }

          if (i<=yo.dias && i===5){
            yo.viernes = yo.total_max_dia
          }

          if (i<=yo.dias && i===6){
            yo.sabado = yo.total_max_dia
          }

          if (i<=yo.dias && i===7){
            yo.domingo = yo.total_max_dia
          }

        }
      }
    },

    descargarPlantilla(){
      const yo = this
      const config = {
        method: 'get',
        url: '/pagricolas/fertilizacion/plantilla/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer'
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {

              const fileURL = window.URL.createObjectURL(new Blob([response.data]))
              const fileLink = document.createElement('a')
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'Plantilla_PRG_AGR.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          });
    },

    validarEditar(datos, a_s) {
      const yo = this

      if (datos['estado'] === '0' || datos['estado'] === '3') {
        const config = {
          method: 'get',
          url: '/pagricolas/parametrosCompleto/?cod=' + yo.id_user+'&&modulo=riego',
          data:'riego',
        }

        axiosIns(config)
            .then(function (response) {
              //Valido almaceno los parametros en variables para despues condicionar
              if(response.status === 200){
                // console.log(datos['empresa'])
                // console.log(datos['cultivo'])
                // console.log(response.data['usuario'][0]['empresa'])
                // console.log(response.data['usuario'][0]['cultivo'])

                if((response.data['usuario']).length>0){
                  if(response.data['usuario'][0]['modulo'] === 'RIEGO' || response.data['usuario'][0]['modulo'] === 'RIEGO, FERTILIZACION' || response.data['usuario'][0]['modulo'] === 'FERTILIZACION, RIEGO'){

                    if (response.data['usuario'][0]['empresa'] === datos['empresa'] ||  response.data['usuario'][0]['empresa']==='TODOS'){
                      // console.log("La empresa del usuario coincide con la empresa de este registro")
                      if (response.data['usuario'][0]['cultivo'] === datos['cultivo'] ||  response.data['usuario'][0]['cultivo']==='TODOS'){
                        // console.log("El cultivo del usuario coincide con el cultivo de este registro")
                        //
                        yo.parametros_usuario = response.data['usuario'][0]
                        const parametros_total = response.data['parametros'].filter(
                          invoice => invoice.nombre === 'LIMITE PROGRAMACION RIEGO'
                        );
                        const parametros_actual = response.data['parametros'].filter(
                          invoice => invoice.nombre === 'LIMITE PROGRAMACION RIEGO SEMANA ACTUAL'
                        );
                        const parametros_sgte = response.data['parametros'].filter(
                          invoice => invoice.nombre === 'LIMITE PROGRAMACION RIEGO SEMANA SIGUIENTE'
                        );

                        //Si es 0 es porque esta inactivo, no se pueden hacer registros
                        if(parametros_total[0]['estado'] === '0'){
                          yo.parametros = parametros_total
                        }
                        else if (a_s){
                          if(parametros_actual[0]['estado'] === '0'){
                            yo.parametros = parametros_actual
                          }else{
                            yo.parametros = [{
                              'valor': response.data['usuario'][0]['valor'],
                              'valor2': response.data['usuario'][0]['valor_1']
                            }]
                          }
                        }
                        else{
                          if(parametros_sgte[0]['estado'] === '0'){
                            yo.parametros = parametros_sgte
                          }else{
                            yo.parametros = [{
                              'valor': response.data['usuario'][0]['valor_2'],
                              'valor2': response.data['usuario'][0]['valor_3']
                            }]
                          }
                        }

                        yo.dia = yo.parametros[0]['valor']
                        yo.hora = yo.parametros[0]['valor2']
                        let valorDia = 0

                        const horaInicial = yo.hora.split(':')

                        if(yo.dia === 'LUNES'){
                          valorDia = 1
                        }else if(yo.dia === 'MARTES'){
                          valorDia = 2
                        }else if(yo.dia === 'MIÉRCOLES'){
                          valorDia = 3
                        }else if(yo.dia === 'JUEVES'){
                          valorDia = 4
                        }else if(yo.dia === 'VIERNES'){
                          valorDia = 5
                        }else if(yo.dia === 'SÁBADO'){
                          valorDia = 6
                        }else if(yo.dia === 'DOMINGO'){
                          valorDia = 7
                        }

                        const ahora = new Date()

                        const fechaInicial = new Date(ahora.getUTCFullYear(), ahora.getUTCMonth(),ahora.getUTCDate(), parseInt(horaInicial[0]), parseInt(horaInicial[1]), parseInt(horaInicial[2]))

                        if (ahora.getDay() < valorDia){
                          yo.mostrarModalEditar(datos)
                          // console.log(datos)
                        }else if(ahora.getDay() === valorDia){
                          if(ahora <= fechaInicial){
                            yo.mostrarModalEditar(datos)
                          }else{
                            yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden editar registros porque se encuentra fuera del límite programado.", 'warning', 5000)
                          }
                        }else{
                          yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden editar registros porque se encuentra fuera del límite programado.", 'warning', 5000)
                        }

                        //
                      }else{
                        yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "Tu usuario no tiene permisos para realizar la edición de este cultivo", 'warning', 5000)
                      }
                    }else{
                      yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "Tu usuario no tiene permisos para realizar la edición de esta sociedad", 'warning', 5000)
                    }

                  }else{
                    yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "Tu usuario solo tiene permisos de visualización.", 'warning', 5000)
                  }



                }else{
                  yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "Tu usuario solo tiene permisos de visualización.", 'warning', 5000)
                }

              }
            })
            .catch(function (error) {
              console.log(error);
            })
            .finally(function (){
              yo.loading = false
            })
      }
      else{
        this.mostrarNotificacion('Advertencia', 'BellIcon', "Solo se pueden editar los registro pendientes u observados.", 'warning', 6000)
      }
    },

    mostrarModalEditar(datos){


      const yo = this
      yo.estadoModalEditar = true
      yo.id_editar = datos['id']
      yo.semana = datos['semana']
      yo.empresa = datos['empresa']

      this.asignarCultivos()
      yo.cultivo = datos['cultivo']
      this.asignarFundos()
      yo.fundo = datos['fundo']
      this.asignarEtapas()
      yo.etapa = datos['etapa']
      this.asignarCampos()
      yo.campo = datos['campo']
      this.asignarTurnos()
      yo.turno = datos['turno']
      this.asignarCodigos()

      yo.codigo_h=datos['cod_homologado']

      yo.variedad = datos['variedad']
      yo.lote = datos['lote']
      yo.valvula = datos['valvula']
      yo.area = datos['area']

      yo.eto = datos['eto']
      yo.kc = datos['kc']
      yo.lr_dia = datos['lr_dia']
      yo.descarga_caudal_hora = datos['descarga_caudal_hora']

      yo.volumen = datos['volumen']
      yo.ciclos_riego = datos['ciclos_riego']
      yo.riego_total = datos['riego_total']
      yo.horas = datos['horas']
      yo.riego_cortina = datos['riego_cortina']
      yo.con_sin_fertilizante = datos['con_sin_fertilizante']

      yo.ciclo_1 = datos['ciclo_1']
      yo.estanque_uno_1 = datos['estanque_uno_1']
      yo.estanque_dos_1 = datos['estanque_dos_1']
      yo.estanque_tres_1 = datos['estanque_tres_1']
      yo.hora_inicio_1 = datos['hora_inicio_1']
      yo.horas_inicio_seg_ciclo = datos['horas_inicio_seg_ciclo']

      yo.ciclo_2 = datos['ciclo_2']
      yo.estanque_uno_2 = datos['estanque_uno_2']
      yo.estanque_dos_2 = datos['estanque_dos_2']
      yo.estanque_tres_2 = datos['estanque_tres_2']
      yo.hora_inicio_2 = datos['hora_inicio_2']
      yo.horas_inicio_ter_ciclo = datos['horas_inicio_ter_ciclo']

      yo.ciclo_3 = datos['ciclo_3']
      yo.estanque_uno_3 = datos['estanque_uno_3']
      yo.estanque_dos_3 = datos['estanque_dos_3']
      yo.estanque_tres_3 = datos['estanque_tres_3']
      yo.hora_inicio_3 = datos['hora_inicio_3']
      yo.horas_inicio_cuarto_ciclo = datos['horas_inicio_cuarto_ciclo']

      yo.ciclo_4 = datos['ciclo_4']
      yo.estanque_uno_4 = datos['estanque_uno_4']
      yo.estanque_dos_4 = datos['estanque_dos_4']
      yo.estanque_tres_4 = datos['estanque_tres_4']
      yo.hora_inicio_4 = datos['hora_inicio_4']
      yo.horas_inicio_quinto_ciclo = datos['horas_inicio_quinto_ciclo']

      yo.ciclo_5 = datos['ciclo_5']
      yo.estanque_uno_5 = datos['estanque_uno_5']
      yo.estanque_dos_5 = datos['estanque_dos_5']
      yo.estanque_tres_5 = datos['estanque_tres_5']
      yo.hora_inicio_5 = datos['hora_inicio_5']
      yo.horas_inicio_sexto_ciclo = datos['horas_inicio_sexto_ciclo']

      yo.ciclo_6 = datos['ciclo_6']
      yo.estanque_uno_6 = datos['estanque_uno_6']
      yo.estanque_dos_6 = datos['estanque_dos_6']
      yo.estanque_tres_6 = datos['estanque_tres_6']
      yo.hora_inicio_6 = datos['hora_inicio_6']
      yo.horas_inicio_septimo_ciclo = datos['horas_inicio_septimo_ciclo']

      yo.ciclo_7 = datos['ciclo_7']
      yo.estanque_uno_7 = datos['estanque_uno_7']
      yo.estanque_dos_7 = datos['estanque_dos_7']
      yo.estanque_tres_7 = datos['estanque_tres_7']
      yo.hora_inicio_7 = datos['hora_inicio_7']


      yo.comentarios = datos['comentarios']

    },

    mostrarModalImportar(valor){
      const yo = this
      const config = {
        method: 'get',
        url: '/pagricolas/parametrosCompleto/?cod=' + yo.id_user+'&&modulo=riego'
      }

      yo.loadingSAM = valor
      yo.loadingSSM = !valor

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              // console.log(response)
              // console.log(response.data['empresa'])
              // console.log(response.data['cultivo'])

              if((response.data['usuario']).length>0){

                if(response.data['usuario'][0]['modulo'] === 'RIEGO' || response.data['usuario'][0]['modulo'] === 'RIEGO, FERTILIZACION' || response.data['usuario'][0]['modulo'] === 'FERTILIZACION, RIEGO'){

                  yo.parametros_usuario = response.data['usuario'][0]
                  const parametros_total = response.data['parametros'].filter(
                    invoice => invoice.nombre === 'LIMITE PROGRAMACION RIEGO'
                  );
                  const parametros_actual = response.data['parametros'].filter(
                    invoice => invoice.nombre === 'LIMITE PROGRAMACION RIEGO SEMANA ACTUAL'
                  );
                  const parametros_sgte = response.data['parametros'].filter(
                    invoice => invoice.nombre === 'LIMITE PROGRAMACION RIEGO SEMANA SIGUIENTE'
                  );

                  if(parametros_total[0]['estado'] === '0'){
                    yo.parametros = parametros_total
                  }
                  else if (valor){
                    if(parametros_actual[0]['estado'] === '0'){
                      yo.parametros = parametros_actual
                    }else{
                      yo.parametros = [{
                        'valor': response.data['usuario'][0]['valor'],
                        'valor2': response.data['usuario'][0]['valor_1']
                      }]

                    }
                  }
                  else{
                    if(parametros_sgte[0]['estado'] === '0'){
                      yo.parametros = parametros_sgte
                    }else{
                      yo.parametros = [{
                        'valor': response.data['usuario'][0]['valor_2'],
                        'valor2': response.data['usuario'][0]['valor_3']
                      }]
                    }
                  }

                  yo.semanaEnviar = valor ? yo.semana : yo.semana_sig

                  yo.dia = yo.parametros[0]['valor']
                  yo.hora = yo.parametros[0]['valor2']

                  let valorDia = 0

                  const horaInicial = yo.hora.split(':')

                  if(yo.dia === 'LUNES'){
                    valorDia = 1
                  }else if(yo.dia === 'MARTES'){
                    valorDia = 2
                  }else if(yo.dia === 'MIÉRCOLES'){
                    valorDia = 3
                  }else if(yo.dia === 'JUEVES'){
                    valorDia = 4
                  }else if(yo.dia === 'VIERNES'){
                    valorDia = 5
                  }else if(yo.dia === 'SÁBADO'){
                    valorDia = 6
                  }else if(yo.dia === 'DOMINGO'){
                    valorDia = 7
                  }

                  const ahora = new Date()

                  const fechaInicial = new Date(ahora.getUTCFullYear(), ahora.getUTCMonth(),ahora.getUTCDate(), parseInt(horaInicial[0]), parseInt(horaInicial[1]), parseInt(horaInicial[2]))

                  if (ahora.getDay() < valorDia){

                    yo.estadoModalImportar = true
                  }
                  else if (ahora.getDay() === valorDia){
                    if(ahora <= fechaInicial){
                      yo.estadoModalImportar = true
                    }else{
                      yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
                    }
                  }else{
                    yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
                  }

                }else{
                  yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "Tu usuario solo tiene permisos de visualización.", 'warning', 5000)
                }


              }else{
                yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "Tu usuario solo tiene permisos de visualización.", 'warning', 5000)
              }
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loadingSAM = false
            yo.loadingSSM = false
          })

    },

    filtros(){
      this.items = this.spd
      this.items = this.items.filter(
          invoice =>
              invoice.empresa === (this.empresaFiltro || invoice.empresa) &&
              invoice.semana === (this.semanaFiltro || invoice.semana) &&
              invoice.cultivo === (this.cultivoFiltro || invoice.cultivo)
      )
      this.totalRows = this.items.length
    },

    buscarResponsable(){
      return new Promise(resolve => {
        const yo = this
        yo.loading = true

        const config = {
          method: 'get',
          url: '/pagricolas/consulta_responsable/?id='+ yo.id_user
        }

        let spd = []

        axiosIns(config)
            .then(function (response) {
              if(response.status === 200){
                // console.log(yo.responsable[0].rol)
                yo.responsable = response.data
                spd = response.data
              }

            })
            .catch(function (error) {
              console.log(error);
              yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontraron datos con el usuario ingresado.", 'warning', 2000)
            })
            .finally(function (){
              resolve()
            })
      });
    },

    aprobar(){
      const yo = this

      const config = {
        method: 'get',
        url: '/pagricolas/riego/editar_estado_riego/?datos='+ yo.dataAutorizar + "*" + yo.estado_aprobar
      }

      // console.log(yo.dataAutorizar)
      // console.log(yo.estado_aprobar)

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se actualizó de manera correcta", 'success', 5000)
            }

          })
          .catch(function (error) {
            console.log(error);
            yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontraron productos con el código ingresado.", 'warning', 2000)
          })
          .finally(function (){
            yo.traerRiegos()
          })
    },

    modal_registro(valor){
      const yo = this
      // console.log(yo.id_user)

      const config = {
        method: 'get',
        url: '/pagricolas/parametrosCompleto/?cod=' + yo.id_user+'&&modulo=riego',
      }

      // console.log(config)

      yo.loadingSAC = valor
      yo.loadingSSC = !valor

      axiosIns(config)
          .then(function (response) {
            // console.log(response.data)
            if(response.status === 200){

              if((response.data['usuario']).length>0){
                if(response.data['usuario'][0]['modulo'] === 'RIEGO' || response.data['usuario'][0]['modulo'] === 'RIEGO, FERTILIZACION' || response.data['usuario'][0]['modulo'] === 'FERTILIZACION, RIEGO'){

                  yo.parametros_usuario = response.data['usuario'][0]
                  const parametros_total = response.data['parametros'].filter(
                    invoice => invoice.nombre === 'LIMITE PROGRAMACION RIEGO'
                  );
                  const parametros_actual = response.data['parametros'].filter(
                    invoice => invoice.nombre === 'LIMITE PROGRAMACION RIEGO SEMANA ACTUAL'
                  );
                  const parametros_sgte = response.data['parametros'].filter(
                    invoice => invoice.nombre === 'LIMITE PROGRAMACION RIEGO SEMANA SIGUIENTE'
                  );

                  if(parametros_total[0]['estado'] === '0'){
                    yo.parametros = parametros_total
                  }
                  else if (valor){
                    if(parametros_actual[0]['estado'] === '0'){
                      yo.parametros = parametros_actual
                    }else{
                      yo.parametros = [{
                        'valor': response.data['usuario'][0]['valor'],
                        'valor2': response.data['usuario'][0]['valor_1']
                      }]
                    }
                  }
                  else{
                    if(parametros_sgte[0]['estado'] === '0'){
                      yo.parametros = parametros_sgte
                    }else{
                      yo.parametros = [{
                        'valor': response.data['usuario'][0]['valor_2'],
                        'valor2': response.data['usuario'][0]['valor_3']
                      }]
                    }
                  }

                  if(valor) {
                    yo.title_sem = `Ingresar nueva programación - Semana ${yo.semana} - Del ${yo.inicioSemana} al ${yo.finSemana}`
                    yo.semanaActual = true

                    //Obtengo el inicio de la semana
                    let partes = yo.inicioSemana.split(" ");
                    let dia = partes[0];
                    let mesTexto = partes[2];
                    let año = partes[4];

                    let mes = yo.convertirMesANumero(mesTexto).toString().padStart(2, '0');
                    let diaFormateado = dia.padStart(2, '0');
                    yo.fechaInicioSemana = `${año}-${mes}-${diaFormateado}`;

                    partes = []

                    //Obtengo el fin de la semana
                    partes = yo.finSemana.split(" ");

                    dia = partes[0];
                    mesTexto = partes[2];
                    console.log(mesTexto)
                    año = partes[4];

                    mes = yo.convertirMesANumero(mesTexto).toString().padStart(2, '0');
                    diaFormateado = dia.padStart(2, '0');
                    yo.fechaFinSemana = `${año}-${mes}-${diaFormateado}`;

                  }else{
                    yo.title_sem = `Ingresar nueva programación - Semana ${yo.semana_sig} - Del ${yo.inicioSemana_sig} al ${yo.finSemana_sig}`
                    yo.semanaActual = false

                    //Obtengo el inicio de la semana
                    let partes = yo.inicioSemana_sig.split(" ");
                    let dia = partes[0];
                    let mesTexto = partes[2];
                    let año = partes[4];

                    let mes = yo.convertirMesANumero(mesTexto).toString().padStart(2, '0');
                    let diaFormateado = dia.padStart(2, '0');
                    yo.fechaInicioSemana = `${año}-${mes}-${diaFormateado}`;

                    partes = []

                    //Obtengo el fin de la semana
                    partes = yo.finSemana_sig.split(" ");
                    dia = partes[0];
                    mesTexto = partes[2];
                    año = partes[4];

                    mes = yo.convertirMesANumero(mesTexto).toString().padStart(2, '0');
                    diaFormateado = dia.padStart(2, '0');
                    yo.fechaFinSemana = `${año}-${mes}-${diaFormateado}`;

                  }

                  yo.dia = yo.parametros[0]['valor']
                  yo.hora = yo.parametros[0]['valor2']

                  let valorDia = 0

                  const horaInicial = yo.hora.split(':')

                  if(yo.dia === 'LUNES'){
                    valorDia = 1
                  }else if(yo.dia === 'MARTES'){
                    valorDia = 2
                  }else if(yo.dia === 'MIÉRCOLES'){
                    valorDia = 3
                  }else if(yo.dia === 'JUEVES'){
                    valorDia = 4
                  }else if(yo.dia === 'VIERNES'){
                    valorDia = 5
                  }else if(yo.dia === 'SÁBADO'){
                    valorDia = 6
                  }else if(yo.dia === 'DOMINGO'){
                    valorDia = 7
                  }

                  const ahora = new Date()

                  const fechaInicial = new Date(ahora.getUTCFullYear(), ahora.getUTCMonth(),ahora.getUTCDate(), parseInt(horaInicial[0]), parseInt(horaInicial[1]), parseInt(horaInicial[2]))

                  if (ahora.getDay() < valorDia){
                    yo.modal_registro_o = true
                  }
                  else if (ahora.getDay() === valorDia){
                    if(ahora <= fechaInicial){
                      yo.modal_registro_o = true
                    }else{
                      yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
                    }
                  }else{
                    yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
                  }

                }else{
                  yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "Tu usuario solo tiene permisos de visualización.", 'warning', 5000)
                }


              }else{
                yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "Tu usuario solo tiene permisos de visualización.", 'warning', 5000)
              }

            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loadingSAC = false
            yo.loadingSSC = false
          })
    },

    descargarRegistros(valor){
      const yo = this
      let datos=[]
      const semmm = valor ? yo.semana : yo.semana_sig

      if (yo.responsable[0].rol === 'JEFE DE RIEGO CORPORATIVO'){
        // datos = yo.items.filter(invoice => invoice.semana === semmm && (invoice.estado === '2' || invoice.estado === '5'))
        datos = yo.spd.filter(invoice => invoice.semana === semmm && (invoice.estado === '2' || invoice.estado === '5'))
      }else{
        // datos = yo.items.filter(invoice => invoice.semana === semmm)
        datos = yo.spd.filter(invoice => invoice.semana === semmm)
      }

      yo.loadingSAD = valor
      yo.loadingSSD = !valor
      let selectedIds = datos.map(item => item.id);
      const data = JSON.stringify(
          {
            "ids" : selectedIds,
            // "datas":datos
          }
      )

      const config = {
        method: 'post',
        url: '/pagricolas/riego/exportar/filter/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
        data : data
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              const fileURL = window.URL.createObjectURL(new Blob([response.data]));
              const fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', "Exportar detalle Riego - semana "+ semmm +".xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
          })
          .catch(function (error) {
            // console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loadingSAD = false
            yo.loadingSSD = false
          });
    }

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: '';
}

.tablaferti{
  min-height: 52vh!important;
}

.tablaferti::-webkit-scrollbar {
  width: 1.35vh;
  height: 1.35vh;
}
.tablaferti::-webkit-scrollbar-track {
  background-color: rgba(171, 171, 171, 0.35);
  border-radius: 6px;
  position: absolute;
}
.tablaferti::-webkit-scrollbar-thumb {
  background-image: linear-gradient(47deg, #82868b, #9ca0a4);
  border-radius: 6px;
  position: absolute;
}

</style>
